<template>
  <div :class="showLoading ? 'main' : 'main pb-100'">
    <div class="loading" v-if="showLoading">
      <van-loading type="spinner" />数据加载中...
    </div>

    <div class="hospital" @click="onGoHospital" v-if="isChat">
      <img src="../../assets/img/robot2.png" />
      <div class="txt">点此咨询</div>
    </div>

    <van-tabs color="#009688" title-active-color="#009688" @click="changeTab" line-height="2px" line-width="40px"
      v-if="!showLoading">
	  <div class="wj" v-if="showWj">
		<span @click="onGoWj">【填写问卷】</span>
	  </div>
      <van-tab v-for="(item, index) in tabList" :title="item.name" :key="index">
        <div v-if="index == 0" class="report">
          <!---------------- 筛查结果报告 -------------------------->
          <div v-if="detailTitle == '筛查结果报告'">
            <div class="report-div" style="padding: 0.5rem 0.3rem 0.3rem 0.3rem">
              <div class="report-info">
                <div class="report-info-left">
                  <div>
                    <span>{{ studentInfo.studentName }}</span>
                    <span>{{ studentInfo.sex }}</span>
                    <span>{{ studentInfo.age | formatAge }}</span>
                  </div>
                  <div class="info-small">
                    {{ studentInfo.schoolName }}{{ studentInfo.clazzName }}
                  </div>

                  <div class="info-small">
                    {{ studentInfo.recordDate | formatDate }}
                  </div>
                </div>

                <div class="report-info-right">
                  <div @click="goQr()">
                    <i class="van-icon van-icon-qr ewm ewm-big font-big" />
                  </div>
                </div>
              </div>
            </div>
			<div class="new-report-div" v-if="!reportVersion" >
			  <div class="new-report-title">筛查结果</div>
			  <table class="new-report-table">
			      <tr>
			        <th>项目名称</th>
			        <th>右眼</th>
			        <th>左眼</th>
			      </tr>
			    <tbody>
			      <tr>
			        <td>裸眼视力</td>
			        <td>{{visionInfo != null && visionInfo.rightNakedeyeVision ? visionInfo.rightNakedeyeVision : "---"}}</td>
			        <td>{{visionInfo != null && visionInfo.leftNakedeyeVision ? visionInfo.leftNakedeyeVision : "---"}}</td>
			      </tr>
			      <tr>
			        <td>戴镜视力</td>
			        <td>{{visionInfo != null && visionInfo.rightGlassesVision ? visionInfo.rightGlassesVision : "---"}}</td>
			        <td>{{visionInfo != null && visionInfo.leftGlassesVision ? visionInfo.leftGlassesVision : "---"}}</td>
			      </tr>
			      <tr>
			        <td>球镜(S)</td>
			        <td>{{ diopterInfo.avg_right_ball | formatFixed2 }}</td>
			        <td>{{ diopterInfo.avg_left_ball | formatFixed2 }}</td>
			      </tr>
			      <tr>
			        <td>柱镜(C)</td>
			        <td>{{ diopterInfo.avg_right_syl | formatFixed2 }}</td>
			        <td>{{ diopterInfo.avg_left_syl | formatFixed2 }}</td>
			      </tr>
			      <tr>
			        <td>轴位(A)</td>
			        <td>{{ diopterInfo.avg_right_axial | formatVal }}</td>
			        <td>{{ diopterInfo.avg_left_axial | formatVal }}</td>
			      </tr>
			      <tr>
			        <td>等效球镜度(SE)</td>
			        <td>{{ diopterInfo.right_se | formatFixed2 }}</td>
			        <td>{{ diopterInfo.left_se | formatFixed2 }}</td>
			      </tr>
			      <tr>
			        <td>眼轴</td>
			        <td>{{ otherInfo.rightAxialLength | formatVal }}</td>
			        <td>{{ otherInfo.leftAxialLength | formatVal }}</td>
			      </tr>
			    </tbody>
			  </table>
			  <div class="new-report-tip">注：以上仅为初筛数据，不作为诊断依据</div>
			</div>
			<div style="padding: 1rem; text-align: center; vertical-align: middle; background: #fff;
			display: flex;flex-direction: column;justify-content: center;" v-if="showNoInfoMsg && reportVersion">
				<div style="color:rgb(0, 150, 136);display: flex;flex-direction: column; align-items: center;gap:0.5em;
				 padding: 0 0 0.3rem; min-height: 73vh" >
					<img src='../../assets/img/docMiss.svg' style="width: 1rem"/>
					暂无检查数据
				</div>
			</div>
            <div class="report-div"  v-if="showVisionInfo && reportVersion">
              <div class="report-div-title" @click="showReport = !showReport">
                <div>视力检查报告</div>
                <van-icon :name="showReport ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showReport">
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>
                    {{
                    visionInfo != null && visionInfo.rightNakedeyeVision
                    ? visionInfo.rightNakedeyeVision
                    : "---"
                    }}
                  </div>
                  <div>裸眼视力</div>
                  <div>
                    {{
                    visionInfo != null && visionInfo.leftNakedeyeVision
                    ? visionInfo.leftNakedeyeVision
                    : "---"
                    }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div>
                    {{
                    visionInfo != null && visionInfo.rightGlassesVision
                    ? visionInfo.rightGlassesVision
                    : "---"
                    }}
                  </div>
                  <div>戴镜视力</div>
                  <div>
                    {{
                    visionInfo != null && visionInfo.leftGlassesVision
                    ? visionInfo.leftGlassesVision
                    : "---"
                    }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div>戴镜方式</div>
                  <div class="width-400">
                    {{
                    visionInfo != null && visionInfo.glassesType
                    ? visionInfo.glassesType
                    : "---"
                    }}
                  </div>
                </div>
                <div v-if="
                    visionInfo != null &&
                    visionInfo.visionExplain != null &&
                    visionInfo.visionExplain != ''
                  " class="report-div-tip">
                  {{ visionInfo.visionExplain }}{{ womenStr }}
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showDiv[0] && reportVersion">
              <div class="report-div-title" @click="showAvgInfo = !showAvgInfo">
                <div>非散瞳（电脑）验光</div>
                <van-icon :name="showAvgInfo ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showAvgInfo">
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.avg_right_ball | formatFixed2 }}</div>
                  <div>球镜(S)</div>
                  <div>{{ diopterInfo.avg_left_ball | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.avg_right_syl | formatFixed2 }}</div>
                  <div>柱镜(C)</div>
                  <div>{{ diopterInfo.avg_left_syl | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.avg_right_axial | formatVal }}</div>
                  <div>轴位(A)</div>
                  <div>{{ diopterInfo.avg_left_axial | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>瞳距(mm)</div>
                  <div class="width-400">
                    {{ diopterInfo.pupilDistance | formatVal }}
                  </div>
                </div>
                <div class="report-div" v-if="showDiv[0]">
                  <div class="report-div-tip">
                    <div class="mb-30">{{ diopterInfo.diopterExplain }}</div>
                    <p>注：</p>
                    <p>
                      1 .“球镜”为近视或远视度数，负值“-”为近视，正值为远视；
                    </p>
                    <p>
                      2
                      .“柱镜”为散光度数；轴位为散光的方向，有散光度数才会有散光轴位。
                    </p>
                    <p>
                      3
                      .电脑验光检查报告为初筛数据，仅作为医生参考，不作为诊断结果，不能直接作为配镜处方。
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="report-div">
              <div class="report-div-title" @click="showFirstInfo = !showFirstInfo">
                <div>初筛结果解读</div>
                <van-icon :name="showFirstInfo ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showFirstInfo">
                <div class="report-div-data">
                  初筛结果: {{ csResult.screeningResult || "---" }}
                </div>
                <div class="report-div-data" style="text-align: left;padding-right: 0.3rem;box-sizing: border-box;"
                  v-if="
                    csResult.screeningResultExplain != null &&
                    csResult.screeningResultExplain != ''
                  ">
                  <div v-html="
                      csResult.screeningResultExplain.replace('\n', '<br><br>')
                    " style="width: 100%"></div>
                </div>
                <div class="report-div-data">
                  检查机构：{{ csResult.checkName }}
                </div>
                <div class="report-div-data">
                  咨询电话：{{ csResult.checkPhone }}
                </div>

                <div class="report-div-tip">
                  温馨提示：{{
                  csResult && csResult.resultsHint
                  ? csResult.resultsHint
                  : "如遇技术问题或对报告结果有疑问，可扫描页面底部二维码进行咨询"
                  }}
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showSj && reportVersion">
              <div class="report-div-title" @click="showSenseInfo = !showSenseInfo">
                <div>视觉检查报告</div>
                <van-icon :name="showSenseInfo ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showSenseInfo">
                <div class="report-div-data">
                  视觉筛查结果: {{ vsualSenseInfo?.result | formatVal }}
                </div>
                <div class="report-div-data">
                  筛查异常项目: {{ vsualSenseInfo?.stringBuilder | formatVal }}
                </div>
              </div>
            </div>
            <div class="report-div" v-if="
                medicalInfo &&
                (medicalInfo.show1 ||
                  medicalInfo.show2 ||
                  medicalInfo.show3 ||
                  medicalInfo.show4) && reportVersion
              ">
              <div class="report-div-title" @click="showMedicalInfo = !showMedicalInfo">
                <div>综合报告</div>
                <van-icon :name="showMedicalInfo ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showMedicalInfo && reportVersion">
                <div class="report-div-data" v-if="medicalInfo?.show1">
					<div style="width: 5%;">
						<input disabled type="checkbox" :checked="medicalInfo.show1" />
					</div>
					<div style="width:90%; text-align: left;padding-left: 0.6em;">
						经视力和屈光筛查，初步判断需要复诊
					</div>
                </div>
                <div class="report-div-data" v-if="medicalInfo?.show2">
					<div style="width: 5%;">
						<input disabled type="checkbox" :checked="medicalInfo.show2" />
					</div>
					<div style="width:90%; text-align: left;padding-left: 0.6em;">
						经脊柱弯曲异常检查，初步判断需要复诊
					</div>
                </div>
                <div class="report-div-data" v-if="medicalInfo?.show3">
					<div style="width: 5%;">
					  <input disabled type="checkbox" :checked="medicalInfo.show3" style="margin-bottom: 1.5em" />
				    </div>
                    <div style="width:90%; text-align: left;padding-left: 0.6em;">
					  经身高体重检查，初步判断体重超标需要复诊
				    </div>
                </div>
                <div class="report-div-data" v-if="medicalInfo?.show4">
					<div style="width: 5%;">
						<input disabled type="checkbox" :checked="medicalInfo.show4" style="margin-bottom: 1.5em" />
					</div>
					<div style="width:90%; text-align: left;padding-left: 0.6em;">
						经龋齿检查存在异常，初步判断龋齿异常需要复诊
					</div>
                </div>
                <div class="report-div-tip">
                  建议尽快到正规医疗机构进行复查以明确诊断。
                </div>
              </div>
            </div>
            <div class="report-div" v-if="
                medicalInfo && 
                ((medicalInfo.babyTeethQu !== undefined &&
                  medicalInfo.babyTeethQu !== null &&
                  medicalInfo.babyTeethQu !== '') ||
                  (medicalInfo.babyTeethShi !== undefined &&
                    medicalInfo.babyTeethShi !== null &&
                    medicalInfo.babyTeethShi !== '') ||
                  (medicalInfo.babyTeethBu !== undefined &&
                    medicalInfo.babyTeethBu !== null &&
                    medicalInfo.babyTeethBu !== '') ||
                  (medicalInfo.permanentTeethQu !== undefined &&
                    medicalInfo.permanentTeethQu !== null &&
                    medicalInfo.permanentTeethQu !== '') ||
                  (medicalInfo.permanentTeethShi !== undefined &&
                    medicalInfo.permanentTeethShi !== null &&
                    medicalInfo.permanentTeethShi != '') ||
                  (medicalInfo.permanentTeethBu !== undefined &&
                    medicalInfo.permanentTeethBu !== null &&
                    medicalInfo.permanentTeethBu != '')) && reportVersion
              ">
              <div class="report-div-title" @click="showTeeth = !showTeeth">
                <div>龋齿模块</div>
                <van-icon :name="showTeeth ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showTeeth">
                <div class="report-div-data">
                  <div>乳牙</div>
                  <div></div>
                  <div>恒牙</div>
                </div>
                <div class="report-div-data">
                  <div>{{ medicalInfo.babyTeethQu || "-" }}</div>
                  <div>缺</div>
                  <div>{{ medicalInfo.permanentTeethQu || "-" }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ medicalInfo.babyTeethShi || "-" }}</div>
                  <div>失</div>
                  <div>{{ medicalInfo.permanentTeethShi || "-" }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ medicalInfo.babyTeethBu || "-" }}</div>
                  <div>补</div>
                  <div>{{ medicalInfo.permanentTeethBu || "-" }}</div>
                </div>
				<div class="report-div-data" v-if="medicalInfo.toothHealth != null && medicalInfo.toothHealth != ''">
				  <div class="report-div-tooth-text">牙齿健康情况：</div>
				  <div class="report-div-tooth-msg">{{ medicalInfo.toothHealth }}</div>
				</div>
				<div class="report-div-data" v-if="medicalInfo.toothArrange != null && medicalInfo.toothArrange != ''">
				  <div class="report-div-tooth-text">牙齿排列情况：</div>
				  <div class="report-div-tooth-msg">{{ medicalInfo.toothArrange }}</div>
				</div>
                <div class="report-div-tip" v-if="medicalInfo.show4">
                  龋齿检查异常，建议到医院进一步诊治
                </div>
              </div>
            </div>
			<div class='report-div no-border-bottom no-border-top' @click="showJz = !showJz"
			  v-if="(medicalInfo && (
			    (medicalInfo.adamResult != null && medicalInfo.adamResult !== '') || 
			    (medicalInfo.generalResult != null && medicalInfo.generalResult !== '') ||
			    (medicalInfo.chestRot != null && medicalInfo.chestRot !== '') ||
			    (medicalInfo.waistChestRot != null && medicalInfo.waistChestRot !== '') ||
			    (medicalInfo.waistRot != null && medicalInfo.waistRot !== '') ||
			    (medicalInfo.isSpineTest != null && medicalInfo.isSpineTest !== '') || 
			    (medicalInfo.forwardBackCheck != null && medicalInfo.forwardBackCheck !== '') ||
			    (medicalInfo.spineHistory != null && medicalInfo.spineHistory !== '') ||
			    (medicalInfo.initialResult != null && medicalInfo.initialResult !== '')
			    ) && reportVersion)">
			  <div class="report-div-title">
					  <div>脊柱弯曲检查结果</div>
					  <van-icon :name="showJz ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
			  </div>
			  <div v-if="showJz">
			    <div class="liter-title" v-if="(medicalInfo.adamResult != null && medicalInfo.adamResult !== '') || 
			    (medicalInfo.generalResult != null && medicalInfo.generalResult !== '') ||
			    (medicalInfo.chestRot != null && medicalInfo.chestRot !== '') ||
			    (medicalInfo.waistChestRot != null && medicalInfo.waistChestRot !== '') ||
			    (medicalInfo.waistRot != null && medicalInfo.waistRot !== '') ||
			    (medicalInfo.isSpineTest != null && medicalInfo.isSpineTest !== '')">
			      <div class="" style="color: #5CC4AB;">脊柱侧弯筛查</div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.generalResult != null && medicalInfo.generalResult !== '')">
			      <div>一般检查</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.generalResult}}</div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.adamResult != null && medicalInfo.adamResult !== '')">
			      <div>前屈试验</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.adamResult}}</div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.chestRot != null && medicalInfo.chestRot !== '') ||
			    (medicalInfo.waistChestRot != null && medicalInfo.waistChestRot !== '') ||
			    (medicalInfo.waistRot != null && medicalInfo.waistRot !== '')">
			      <div class="width-400" style="width: 4rem;color: #5CC4AB;">躯干生物测量仪检查</div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.chestRot != null && medicalInfo.chestRot !== '')">
			      <div>胸  段</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.chestRot}}<br><span v-if="medicalInfo.chestAtr">躯干旋转角度(ATR){{ medicalInfo.chestAtr }}°</span></div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.waistChestRot != null && medicalInfo.waistChestRot !== '')">
			      <div>腰胸段</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.waistChestRot}}<br><span v-if="medicalInfo.waistChestAtr">躯干旋转角度(ATR){{ medicalInfo.waistChestAtr }}°</span></div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.waistRot != null && medicalInfo.waistRot !== '')">
			      <div>腰  段</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.waistRot}}<br><span v-if="medicalInfo.waistAtr">躯干旋转角度(ATR){{ medicalInfo.waistAtr }}°</span></div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.isSpineTest != null && medicalInfo.isSpineTest !== '')">
			      <div>是否运动试验</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.isSpineTest}}</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.isSpineTest == '是'">
			      <div class="width-400" style="width: 4rem;color: #5CC4AB;">试验后躯干生物测量仪检查</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.isSpineTest == '是'">
			      <div>胸段ATR</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{ medicalInfo.testChestAtr }}°</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.isSpineTest == '是'">
			      <div>腰胸段ATR</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{ medicalInfo.testWaistChestAtr }}°</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.isSpineTest == '是'">
			      <div>腰段ATR</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{ medicalInfo.testWaistAtr }}°</div>
			    </div>
			    <div class=" liter-title" v-if="medicalInfo.forwardBackCheck != null && medicalInfo.forwardBackCheck !== ''">
			      <div class="" style="color: #5CC4AB;">脊柱前后弯曲异常筛查</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.forwardBackCheck != null && medicalInfo.forwardBackCheck !== ''">
			      <div>一般检查</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.forwardBackCheck}}</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.proneTest != null && medicalInfo.proneTest !== ''">
			      <div>俯卧试验</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.proneTest}}</div>
			    </div>
			    <div class="liter-title" v-if="medicalInfo.spineHistory != null && medicalInfo.spineHistory !== ''">
			      <div class="" style="color: #5CC4AB;">脊柱病史</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.spineHistory != null && medicalInfo.spineHistory !== ''">
			      <div></div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{ medicalInfo.spineHistory }}</div>
			    </div>
			    <div class="liter-title" v-if="medicalInfo.initialResult != null && medicalInfo.initialResult !== ''">
			      <div class="" style="color: #5CC4AB;">初筛结果</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.initialResult != null && medicalInfo.initialResult !== ''">
			      <div></div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{ medicalInfo.initialResult }}</div>
			    </div>
			  </div>
			</div>
			<!-- <div class="report-div" v-if="
                medicalInfo &&
                ((medicalInfo.show5 !== undefined &&
                  medicalInfo.show5 !== null &&
                  medicalInfo.show5 !== '' &&
                  medicalInfo.show5 !== '无侧弯') ||
                  (medicalInfo.show6 !== undefined &&
                    medicalInfo.show6 !== null &&
                    medicalInfo.show6 !== '' &&
                    medicalInfo.show6 !== '无侧弯') ||
                  (medicalInfo.show7 !== undefined &&
                    medicalInfo.show7 !== null &&
                    medicalInfo.show7 !== '' &&
                    medicalInfo.show7 !== '无侧弯') ||
                  (medicalInfo.show8 !== undefined &&
                    medicalInfo.show8 !== null &&
                    medicalInfo.show8 !== '' &&
                    medicalInfo.show8 !== '无侧弯') ||
                  (medicalInfo.show9 !== undefined &&
                    medicalInfo.show9 !== null &&
                    medicalInfo.show9 !== '' &&
                    medicalInfo.show9 !== '无侧弯') ||
                  (medicalInfo.show10 !== undefined &&
                    medicalInfo.show10 !== null &&
                    medicalInfo.show10 !== '' &&
                    medicalInfo.show10 !== '无侧弯') ||
                  (medicalInfo.show11 !== undefined &&
                    medicalInfo.show11 !== null &&
                    medicalInfo.show11 !== '' &&
                    medicalInfo.show11 !== '无侧弯') ||
                  (medicalInfo.show12 !== undefined &&
                    medicalInfo.show12 !== null &&
                    medicalInfo.show12 !== '' &&
                    medicalInfo.show12 !== '无侧弯'))
              ">
              <div class="report-div-title" @click="showJz = !showJz">
                <div>脊柱检查</div>
                <van-icon :name="showJz ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showJz">
                <div class="report-div-data">
                  <div>胸段</div>
                  <div class="width-400">
                    {{
                    medicalInfo.show5 == 0
                    ? "正常"
                    : medicalInfo.show5 == 1
                    ? "侧弯"
                    : medicalInfo.show5 || "---"
                    }}<span v-if="medicalInfo.show6">{{ medicalInfo.show6 }}度</span>
                    &nbsp;
                  </div>
                </div>
                <div class="report-div-data">
                  <div>腰胸段</div>
                  <div class="width-400">
                    {{
                    medicalInfo.show7 == 0
                    ? "正常"
                    : medicalInfo.show7 == 1
                    ? "侧弯"
                    : medicalInfo.show7 || "---"
                    }}<span v-if="medicalInfo.show6">{{ medicalInfo.show8 }}度</span>
                    &nbsp;
                  </div>
                </div>
                <div class="report-div-data">
                  <div>腰段</div>
                  <div class="width-400">
                    {{
                    medicalInfo.show9 == 0
                    ? "正常"
                    : medicalInfo.show9 == 1
                    ? "侧弯"
                    : medicalInfo.show9 || "---"
                    }}<span v-if="medicalInfo.show6">{{ medicalInfo.show10 }}度</span>
                    &nbsp;
                  </div>
                </div>
                <div class="report-div-data">
                  <div>前后弯曲</div>
                  <div class="width-400">
                    {{
                    medicalInfo.show11 == 0
                    ? "正常"
                    : medicalInfo.show11 == 1
                    ? "侧弯"
                    : medicalInfo.show11 || "---"
                    }}<span v-if="medicalInfo.show6">{{ medicalInfo.show12 }}度</span>
                    &nbsp;
                  </div>
                </div>
                <div class="report-div-tip" v-if="medicalInfo.show2">
                  脊柱检查异常，建议到医院进一步诊治
                </div>
              </div>
            </div>
            -->
			<div class="report-div" v-if="
                medicalInfo &&
                ((medicalInfo.sg !== undefined &&
                  medicalInfo.sg !== null &&
                  medicalInfo.sg !== '') ||
                  (medicalInfo.tz !== undefined &&
                    medicalInfo.tz !== null &&
                    medicalInfo.tz !== '') ||
                  (medicalInfo.xy !== undefined &&
                    medicalInfo.xy !== null &&
                    medicalInfo.xy !== '') ||
                  (medicalInfo.show14 !== undefined &&
                    medicalInfo.show14 !== null &&
                    medicalInfo.show14 !== '') ||
                  (medicalInfo.show16 !== undefined &&
                    medicalInfo.show16 !== null &&
                    medicalInfo.show16 !== '') ||
                  (medicalInfo.show13 !== undefined &&
                    medicalInfo.show13 !== null &&
                    medicalInfo.show13 !== '') ||
                  (medicalInfo.show15 !== undefined &&
                    medicalInfo.show15 !== null &&
                    medicalInfo.show15 !== '')) && reportVersion
              ">
              <div class="report-div-title" @click="showTj = !showTj">
                <div>其他体检</div>
                <van-icon :name="showTj ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showTj">
                <div class="report-div-data-big">
                  <div>
                    身高：{{ medicalInfo.sg ? medicalInfo.sg + "cm" : "---" }}
                  </div>
                  <div>
                    体重：{{ medicalInfo.tz ? medicalInfo.tz + "kg" : "---" }}
                  </div>
                  <div>血压：{{ medicalInfo.xy ? medicalInfo.xy : "---" }}</div>
				  <div>腰围：{{ medicalInfo.waistLine ? medicalInfo.waistLine :'---' }}</div>
                  <div>
                    肺活量：{{
                    medicalInfo.lungAbelSize
                    ? medicalInfo.lungAbelSize
                    : "---"
                    }}
                  </div>
				  <div class="report-div-data">
				    {{ studentInfo.sex == "男" ? "是否遗精：" : "是否月经：" }}
				    {{
				    studentInfo.sex == "男"
				    ? medicalInfo.show14 || "---"
				    : medicalInfo.show13 || "---"
				    }}
				  </div>
				  <div class="report-div-data">
				    {{
				    studentInfo.sex == "男"
				    ? "首次遗精年龄："
				    : "首次月经年龄："
				    }}{{
				    studentInfo.sex == "男"
				    ? medicalInfo.show16 || "---"
				    : medicalInfo.show15 || "---"
				    }}
				  </div>
                </div>
              </div>
			  
            </div>
            <div class="report-div" v-if="showDiv[1] && reportVersion">
              <div class="report-div-title" @click="showDipterInfo = !showDipterInfo">
                <div>附：电脑验光检查详细结果</div>
                <van-icon :name="showDipterInfo ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showDipterInfo">
                <div class="report-div-data">
                  <div class="width-160-2"></div>
                  <div class="width-160-2">球镜(S)</div>
                  <div class="width-160-2">柱镜(C)</div>
                  <div sclass="width-160">轴位(A)</div>
                </div>
                <div class="report-div-data">右眼(R)</div>
                <div class="report-div-data">
                  <div class="width-160-1">1</div>
                  <div class="width-160-2">
                    {{ diopterInfo.first_right_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.first_right_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.first_right_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">2</div>
                  <div class="width-160-2">
                    {{ diopterInfo.second_right_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.second_right_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.second_right_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">3</div>
                  <div class="width-160-2">
                    {{ diopterInfo.third_right_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.third_right_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.third_right_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">均值</div>
                  <div class="width-160-2">
                    {{ diopterInfo.avg_right_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.avg_right_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.avg_right_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">S.E</div>
                  <div class="width-400">
                    {{ diopterInfo.right_se | formatFixed2 }}
                  </div>
                </div>
                <div class="report-div-data">左眼(L)</div>
                <div class="report-div-data">
                  <div class="width-160-1">1</div>
                  <div class="width-160-2">
                    {{ diopterInfo.first_left_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.first_left_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.first_left_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">2</div>
                  <div class="width-160-2">
                    {{ diopterInfo.second_left_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.second_left_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.second_left_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">3</div>
                  <div class="width-160-2">
                    {{ diopterInfo.third_left_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.third_left_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.third_left_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">均值</div>
                  <div class="width-160-2">
                    {{ diopterInfo.avg_left_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.avg_left_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.avg_left_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">S.E</div>
                  <div class="width-400">
                    {{ diopterInfo.left_se | formatFixed2 }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-2">瞳距(mm)</div>
                  <div class="width-400">
                    {{ diopterInfo.pupilDistance || "---" }}
                  </div>
                </div>

                <div class="report-div-tip" v-if="
                    diopterInfo.diopterExplain != null &&
                    diopterInfo.diopterExplain != ''
                  ">
                  {{ diopterInfo.diopterExplain }}
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showDiv[14] && reportVersion">
              <div class="report-div-title" @click="showPress = !showPress">
                <div>眼压检查</div>
                <van-icon :name="showPress ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showPress">
                <div>右眼: {{ otherInfo.rightEyePressure | formatVal }}</div>
                <div>左眼: {{ otherInfo.leftEyePressure | formatVal }}</div>
              </div>
            </div>
            <div class="report-div" v-if="showArray[1] && reportVersion">
              <div class="report-div-title" @click="showTable(1)">
                <div>裂隙灯</div>
                <van-icon :name="showTr[1] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showTr[1]" class="img-table">
                <div>
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightLamp.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>
                <div>
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftLamp.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                  &nbsp;
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showArray[2] && reportVersion">
              <div class="report-div-title" @click="showTable(2)">
                <div>干眼检查</div>
                <van-icon :name="showTr[2] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showTr[2]" class="img-table">
                <div colspan="2">
                  <span v-for="(item, index) in otherInfo.dryEye.split(',')" :key="index">
                    <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                  </span>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[3] && reportVersion">
              <div class="report-div-title" @click="showTable(3)">
                <div>Pentacam</div>
                <van-icon :name="showTr[3] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-title" @click="showTable(3)">
                Pentacam<img src="../../assets/img/menudown.png" :class="showTr[3] ? 'menuup' : 'menudown'" />
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div></div>
                <div>右眼</div>
                <div>左眼</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div>K1(D)</div>
                <div>{{ otherInfo.pentacamRightK1 | formatVal }}</div>
                <div>{{ otherInfo.pentacamLeftK1 | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div>K2(D)</div>
                <div>{{ otherInfo.pentacamRightK2 | formatVal }}</div>
                <div>{{ otherInfo.pentacamLeftK2 | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div> KM(D)</div>
                <div>{{ otherInfo.pentacamRightKm | formatVal}}</div>
                <div>{{ otherInfo.pentacamLeftKm | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div>Astig</div>
                <div>{{ otherInfo.pentacamRightAstig | formatVal }}</div>
                <div>{{ otherInfo.pentacamLeftAstig | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div>Axial Length</div>
                <div>{{ otherInfo.pentacamRightAxial | formatVal }}</div>
                <div>{{ otherInfo.pentacamLeftAxial | formatVal }}</div>
              </div>
              <div v-if="showTr[3]" class="img-table">
                <div>
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightPentacam.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>
                <div>
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftPentacam.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[4] && reportVersion">
              <div class="report-div-title" @click="showTable(4)">
                <div>生物力学</div>
                <van-icon :name="showTr[4] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showTr[4]" class="img-table">
                <div>
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightBiologyForce.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>
                <div>
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftBiologyForce.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[5] && reportVersion">
              <div class="report-div-title" @click="showTable(5)">
                <div>角膜地形图</div>
                <van-icon :name="showTr[5] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showTr[5]" class="img-table">
                <div>
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(
                        item, index
                      ) in otherInfo.rightBiometricsPicture.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div>
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(
                        item, index
                      ) in otherInfo.leftBiometricsPicture.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
            <div class="report-div" v-if="(showArray[6] || showArray[18]) && reportVersion">
              <div class="report-div-title" @click="showTable(6, 18)">
                <div>生物测量仪</div>
                <van-icon :name="showTr[6] || showTr[18] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showTr[6] && showArray[6]" class="mrl-30">
                <div class="report-div-title">眼轴</div>
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightAxialLength | formatVal }}</div>
                  <div>眼轴</div>
                  <div>{{ otherInfo.leftAxialLength | formatVal }}</div>
                </div>
                <!-- <div class="report-div-data">
                  <div>{{ otherInfo.rightEyeCurvatureR1 | formatVal }}</div>
                  <div>曲率K1</div>
                  <div>{{ otherInfo.leftEyeCurvatureR1 | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightEyeCurvatureR2 | formatVal }}</div>
                  <div>曲率K2</div>
                  <div>{{ otherInfo.leftEyeCurvatureR2 | formatVal }}</div>
                </div> -->
                <!-- <div class="report-div-tip">
                  <div style="color: rgb(0, 150, 136)">右眼</div>
                  <div class="mt-20">
                    <div>
                      近视临界点眼轴长度：{{
                      otherInfo ? otherInfo.rightAxialLength : ""
                      }}mm
                    </div>
                    <div style="margin-top: 0.15rem">
                      当前屈光度约为：{{
                      otherInfo.map ? otherInfo.map.rqgd : ""
                      }}D(±0.5D)
                    </div>
                    <div style="margin-top: 0.15rem">
                      {{ otherInfo.map ? otherInfo.map.rpdts : "" }}
                    </div>
                  </div>
                  <div style="margin-top: 0.4rem; color: rgb(0, 150, 136)">
                    左眼
                  </div>

                  <div class="mt-20">
                    <div>
                      近视临界点眼轴长度:{{
                      otherInfo ? otherInfo.leftAxialLength : ""
                      }}mm
                    </div>
                    <div class="mt-20">
                      当前屈光度约为:{{
                      otherInfo.map ? otherInfo.map.lqgd : ""
                      }}D(±0.5D)
                    </div>
                    <div class="mt-20">
                      {{ otherInfo.map ? otherInfo.map.lpdts : "" }}
                    </div>
                  </div>
                </div>
                <div class="report-div" style="padding: 0 0.3rem">
                  <div style="text-align: left">
                    -为近视，+为远视，此为等效球镜的理论平均值，存在个体差异，数值仅供参考
                  </div>
                  <div>{{ otherInfo.map ? otherInfo.map.lpdts : "" }}</div>
                </div> -->
                <div class="report-div-title">角膜曲率</div>
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightEyeCurvatureR1 | formatVal }}</div>
                  <div>曲率K1/R1</div>
                  <div>{{ otherInfo.leftEyeCurvatureR1 | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightEyeCurvatureR2 | formatVal }}</div>
                  <div>曲率K2/R2</div>
                  <div>{{ otherInfo.leftEyeCurvatureR2 | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightAxialView1 | formatVal }}</div>
                  <div>@轴位1</div>
                  <div>{{ otherInfo.leftAxialView1 | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightAxialView2 | formatVal }}</div>
                  <div>@轴位2</div>
                  <div>{{ otherInfo.leftAxialView2 | formatVal }}</div>
                </div>
                <div class="report-div-title">其他参数</div>
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightAcd | formatVal }}</div>
                  <div>前房深度</div>
                  <div>{{ otherInfo.leftAcd | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightWtw | formatVal }}</div>
                  <div>白到白</div>
                  <div>{{ otherInfo.leftWtw | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightCentreCorneaPly | formatVal }}</div>
                  <div>角膜厚度</div>
                  <div>{{ otherInfo.leftCentreCorneaPly | formatVal }}</div>
                </div>
              </div>
              <div v-if="showTr[18] && showArray[18]" class="img-table" style="text-align: center">
                <div>
                  <div>
                    <span v-for="(
                        item, index
                      ) in otherInfo.rightTopographyPicture.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[7] && reportVersion">
              <div class="report-div-title" @click="showTable(7)">
                <div>角膜内皮细胞计</div>
                <van-icon :name="showTr[7] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showTr[7]" class="img-table">
                <div>
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightXBJ.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div>
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftXBJ.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[8] && reportVersion">
              <div class="report-div-title" @click="showTable(8)">
                <div>视野计</div>
                <van-icon :name="showTr[8] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showTr[8]" class="img-table">
                <div>
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightPerimeter.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div>
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftPerimeter.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[9] && reportVersion">
              <div class="report-div-title" @click="showTable(9)">
                <div>OCT</div>
                <van-icon :name="showTr[9] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div></div>
                <div>右眼</div>
                <div>左眼</div>
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div>脉络膜厚度</div>
                <div>{{ otherInfo.octRightThickness | formatVal }}</div>
                <div>{{ otherInfo.octLeftThickness | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div>平均杯盘比</div>
                <div>{{ otherInfo.octRightAvgRatio | formatVal }}</div>
                <div>{{ otherInfo.octLeftAvgRatio | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div>垂直杯盘比</div>
                <div>{{ otherInfo.octRightVerticalRatio | formatVal}}</div>
                <div>{{ otherInfo.octLeftVerticalRatio | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div>RNFL平均厚度</div>
                <div>{{ otherInfo.octRightAvgThickness | formatVal }}</div>
                <div>{{ otherInfo.octLeftAvgThickness | formatVal }}</div>
              </div>
              <div v-if="showTr[9]" class="img-table">
                <div>
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightOCT.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div>
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftOCT.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[10] && reportVersion">
              <div class="report-div-title" @click="showTable(10)">
                <div>眼底检查</div>
                <van-icon :name="showTr[10] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showTr[10]" class="img-table">
                <div>
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightFundusCamera.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div>
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftFundusCamera.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!------------------------------------------------------->

          <!--------------- 学生重点常见病监测表 ------------------>
          <div v-if="detailTitle == '学生重点常见病监测表'">
            <div class="report-div" style="padding: 0.3rem">
              <div class="report-info">
                <div class="report-info-left">
                  <div>
                    <span>{{ studentInfo.studentName }}</span>
                    <span>{{ studentInfo.sex }}</span>
                    <span>{{ studentInfo.age | formatAge }}</span>
                  </div>
                  <div class="info-small">
                    {{ studentInfo.schoolName }} {{ studentInfo.clazzName }}
                  </div>
                  <div class="info-small">
                    {{ studentInfo.recordDate | formatDate }}
                  </div>
                </div>
                <div class="report-info-right">
                  <div @click="goQr()">
                    <i class="van-icon van-icon-qr ewm ewm-big font-big" />
                  </div>
                </div>
              </div>
            </div>
            <div class="report-div" v-if="
                medicalInfo &&
                (medicalInfo.show1 ||
                  medicalInfo.show2 ||
                  medicalInfo.show3 ||
                  medicalInfo.show4)
              ">
              <div class="report-div-title" @click="showAllReport = !showAllReport">
                <div>综合报告</div>
                <van-icon :name="showAllReport ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showAllReport">
                <div class="report-div-data" v-if="medicalInfo.show1">
					<div style="width: 5%;">
						<input disabled type="checkbox" :checked="medicalInfo.show1" />
						
					</div>
					<div style="width:90%; text-align: left;padding-left: 0.6em;">
						经视力和屈光筛查，初步判断需要复诊
					</div>
                </div>
                <div class="report-div-data" v-if="medicalInfo.show2">
					<div style="width: 5%;">
						<input disabled type="checkbox" :checked="medicalInfo.show2" />
					</div>
					<div style="width:90%; text-align: left;padding-left: 0.6em;">
						经脊柱弯曲异常检查，初步判断需要复诊
					</div>
                </div>
                <div class="report-div-data" v-if="medicalInfo.show3">
					<div style="width: 5%;">
						<input disabled type="checkbox" :checked="medicalInfo.show3" />
					</div>
					<div style="width:90%; text-align: left;padding-left: 0.6em;">
						经身高体重检查，初步判断体重超标需要复诊
					</div>
                  
                </div>
                <div class="report-div-data" v-if="medicalInfo.show4">
					<div style="width: 5%;">
						<input disabled type="checkbox" :checked="medicalInfo.show4" />
					</div>
					<div style="width:90%; text-align: left;padding-left: 0.6em;">
						经龋齿检查存在异常，初步判断龋齿异常需要复诊
					</div>
                </div>
                <div class="report-div-tip">
                  建议尽快到正规医疗机构进行复查以明确诊断。
                </div>
              </div>
            </div>

            <div class="report-div"  v-if="showVisionInfo">
              <div class="report-div-title" @click="showReport = !showReport">
                <div>视力检查报告</div>
                <van-icon :name="showReport ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>

              <div v-if="showReport">
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>
                    {{
                    visionInfo != null && visionInfo.rightGlassesVision
                    ? visionInfo.rightGlassesVision
                    : "---"
                    }}
                  </div>
                  <div>戴镜</div>
                  <div>
                    {{
                    visionInfo != null && visionInfo.leftGlassesVision
                    ? visionInfo.leftGlassesVision
                    : "---"
                    }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div>
                    {{
                    visionInfo != null && visionInfo.rightNakedeyeVision
                    ? visionInfo.rightNakedeyeVision
                    : "---"
                    }}
                  </div>
                  <div>裸眼</div>
                  <div>
                    {{
                    visionInfo != null && visionInfo.leftNakedeyeVision
                    ? visionInfo.leftNakedeyeVision
                    : "---"
                    }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div>戴镜方式</div>
                  <div style="width: 4rem">
                    {{
                    visionInfo != null && visionInfo.glassesType
                    ? visionInfo.glassesType
                    : "---"
                    }}
                  </div>
                </div>
                <div class="report-div-tip" v-if="
                    visionInfo != null &&
                    visionInfo.visionExplain != null &&
                    visionInfo.visionExplain != ''
                  ">
                  {{ visionInfo.visionExplain }}{{ womenStr }}
                </div>
              </div>
            </div>
            <div class="report-div">
              <div class="report-div-title" @click="showFirstInfo = !showFirstInfo">
                <div>初筛结果解读</div>
                <van-icon :name="showFirstInfo ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showFirstInfo">
                <div class="report-div-data">
                  初筛结果: {{ csResult.screeningResult || "---" }}
                </div>
                <div class="report-div-data" style="text-align: left;box-sizing: border-box;padding-right: 0.3rem;"
                  v-if="
                    csResult.screeningResultExplain != null &&
                    csResult.screeningResultExplain != ''
                  ">
                  <div v-html="csResult.screeningResultExplain.replace('\n', '<br><br>')"
                    style="width: 100%;text-align:left;"></div>
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showDiv[3]">
              <div class="report-div-title" @click="showAvgInfo = !showAvgInfo">
                <div>非散瞳（电脑）验光</div>
                <van-icon :name="showAvgInfo ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showAvgInfo">
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.avg_right_ball | formatFixed2 }}</div>
                  <div>球镜(S)</div>
                  <div>{{ diopterInfo.avg_left_ball | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.avg_right_syl | formatFixed2 }}</div>
                  <div>柱镜(C)</div>
                  <div>{{ diopterInfo.avg_left_syl | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.avg_right_axial | formatVal }}</div>
                  <div>轴位(A)</div>
                  <div>{{ diopterInfo.avg_left_axial | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>瞳距(mm)</div>
                  <div class="width-400">
                    {{ diopterInfo.pupilDistance | formatVal }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showDiv[3]" class="report-div">
              <div class="report-div-tip" v-if="diopterInfo.diopterExplain" style="margin-bottom: 0.3rem">
                <p>{{ diopterInfo.diopterExplain }}</p>
                <p>注：</p>
                <p>1 .“球镜”为近视或远视度数，负值“-”为近视，正值为远视；</p>
                <p>
                  2
                  .“柱镜”为散光度数；轴位为散光的方向，有散光度数才会有散光轴位。
                </p>
                <p>
                  3
                  .电脑验光检查报告为初筛数据，仅作为医生参考，不作为诊断结果，不能直接作为配镜处方。
                </p>
              </div>
            </div>
            <div class="report-div" v-if="showDiv[14]">
              <div class="report-div-title" @click="showPress = !showPress">
                <div>眼压检查</div>
                <van-icon :name="showPress ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showPress">
                <div>右眼: {{ otherInfo.rightEyePressure | formatVal }}</div>
                <div>左眼: {{ otherInfo.leftEyePressure | formatVal }}</div>
              </div>
            </div>
            <div class="report-div" v-if="
                medicalInfo &&
                ((medicalInfo.babyTeethQu !== undefined &&
                  medicalInfo.babyTeethQu !== null &&
                  medicalInfo.babyTeethQu !== '') ||
                  (medicalInfo.babyTeethShi !== undefined &&
                    medicalInfo.babyTeethShi !== null &&
                    medicalInfo.babyTeethShi !== '') ||
                  (medicalInfo.babyTeethBu !== undefined &&
                    medicalInfo.babyTeethBu !== null &&
                    medicalInfo.babyTeethBu !== '') ||
                  (medicalInfo.permanentTeethQu !== undefined &&
                    medicalInfo.permanentTeethQu !== null &&
                    medicalInfo.permanentTeethQu !== '') ||
                  (medicalInfo.permanentTeethShi !== undefined &&
                    medicalInfo.permanentTeethShi !== null &&
                    medicalInfo.permanentTeethShi != '') ||
                  (medicalInfo.permanentTeethBu !== undefined &&
                    medicalInfo.permanentTeethBu !== null &&
                    medicalInfo.permanentTeethBu != ''))
              ">
              <div class="report-div-title" @click="showTeeth = !showTeeth">
                <div>龋齿模块</div>
                <van-icon :name="showTeeth ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showTeeth">
                <div class="report-div-data">
                  <div>乳牙</div>
                  <div></div>
                  <div>恒牙</div>
                </div>
                <div class="report-div-data">
                  <div>{{ medicalInfo.babyTeethQu || "-" }}</div>
                  <div>缺</div>
                  <div>{{ medicalInfo.permanentTeethQu || "-" }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ medicalInfo.babyTeethShi || "-" }}</div>
                  <div>失</div>
                  <div>{{ medicalInfo.permanentTeethShi || "-" }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ medicalInfo.babyTeethBu || "-" }}</div>
                  <div>补</div>
                  <div>{{ medicalInfo.permanentTeethBu || "-" }}</div>
                </div>
				<div class="report-div-data" v-if="medicalInfo.toothHealth != null && medicalInfo.toothHealth != ''">
				  <div class="report-div-tooth-text">牙齿健康情况：</div>
				  <div class="report-div-tooth-msg">{{ medicalInfo.toothHealth }}</div>
				</div>
				<div class="report-div-data" v-if="medicalInfo.toothArrange != null && medicalInfo.toothArrange != ''">
				  <div class="report-div-tooth-text">牙齿排列情况：</div>
				  <div class="report-div-tooth-msg">{{ medicalInfo.toothArrange }}</div>
				</div>
                <div class="report-div-tip" v-if="medicalInfo.show4">
                  龋齿检查异常，建议到医院进一步诊治
                </div>
              </div>
            </div>
			<div class='report-div no-border-bottom no-border-top' @click="showJz = !showJz"
			  v-if="(medicalInfo && (
			    (medicalInfo.adamResult != null && medicalInfo.adamResult !== '') || 
			    (medicalInfo.generalResult != null && medicalInfo.generalResult !== '') ||
			    (medicalInfo.chestRot != null && medicalInfo.chestRot !== '') ||
			    (medicalInfo.waistChestRot != null && medicalInfo.waistChestRot !== '') ||
			    (medicalInfo.waistRot != null && medicalInfo.waistRot !== '') ||
			    (medicalInfo.isSpineTest != null && medicalInfo.isSpineTest !== '') || 
			    (medicalInfo.forwardBackCheck != null && medicalInfo.forwardBackCheck !== '') ||
			    (medicalInfo.spineHistory != null && medicalInfo.spineHistory !== '') ||
			    (medicalInfo.initialResult != null && medicalInfo.initialResult !== '')
			    ) && reportVersion)">
			  <div class="report-div-title">
				  <div>脊柱弯曲检查结果</div>
				  <van-icon :name="showJz ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
			  </div>
			  <div v-if="showJz">
			    <div class="liter-title" v-if="(medicalInfo.adamResult != null && medicalInfo.adamResult !== '') || 
			    (medicalInfo.generalResult != null && medicalInfo.generalResult !== '') ||
			    (medicalInfo.chestRot != null && medicalInfo.chestRot !== '') ||
			    (medicalInfo.waistChestRot != null && medicalInfo.waistChestRot !== '') ||
			    (medicalInfo.waistRot != null && medicalInfo.waistRot !== '') ||
			    (medicalInfo.isSpineTest != null && medicalInfo.isSpineTest !== '')">
			      <div class="" style="color: #5CC4AB;">脊柱侧弯筛查</div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.generalResult != null && medicalInfo.generalResult !== '')">
			      <div>一般检查</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.generalResult}}</div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.adamResult != null && medicalInfo.adamResult !== '')">
			      <div>前屈试验</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.adamResult}}</div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.chestRot != null && medicalInfo.chestRot !== '') ||
			    (medicalInfo.waistChestRot != null && medicalInfo.waistChestRot !== '') ||
			    (medicalInfo.waistRot != null && medicalInfo.waistRot !== '')">
			      <div class="width-400" style="width: 4rem;color: #5CC4AB;">躯干生物测量仪检查</div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.chestRot != null && medicalInfo.chestRot !== '')">
			      <div>胸  段</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.chestRot}}<br><span v-if="medicalInfo.chestAtr">躯干旋转角度(ATR){{ medicalInfo.chestAtr }}°</span></div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.waistChestRot != null && medicalInfo.waistChestRot !== '')">
			      <div>腰胸段</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.waistChestRot}}<br><span v-if="medicalInfo.waistChestAtr">躯干旋转角度(ATR){{ medicalInfo.waistChestAtr }}°</span></div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.waistRot != null && medicalInfo.waistRot !== '')">
			      <div>腰  段</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.waistRot}}<br><span v-if="medicalInfo.waistAtr">躯干旋转角度(ATR){{ medicalInfo.waistAtr }}°</span></div>
			    </div>
			    <div class="report-div-data" v-if="(medicalInfo.isSpineTest != null && medicalInfo.isSpineTest !== '')">
			      <div>是否运动试验</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.isSpineTest}}</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.isSpineTest == '是'">
			      <div class="width-400" style="width: 4rem;color: #5CC4AB;">试验后躯干生物测量仪检查</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.isSpineTest == '是'">
			      <div>胸段ATR</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{ medicalInfo.testChestAtr }}°</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.isSpineTest == '是'">
			      <div>腰胸段ATR</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{ medicalInfo.testWaistChestAtr }}°</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.isSpineTest == '是'">
			      <div>腰段ATR</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{ medicalInfo.testWaistAtr }}°</div>
			    </div>
			    <div class=" liter-title" v-if="medicalInfo.forwardBackCheck != null && medicalInfo.forwardBackCheck !== ''">
			      <div class="" style="color: #5CC4AB;">脊柱前后弯曲异常筛查</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.forwardBackCheck != null && medicalInfo.forwardBackCheck !== ''">
			      <div>一般检查</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.forwardBackCheck}}</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.proneTest != null && medicalInfo.proneTest !== ''">
			      <div>俯卧试验</div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{medicalInfo.proneTest}}</div>
			    </div>
			    <div class="liter-title" v-if="medicalInfo.spineHistory != null && medicalInfo.spineHistory !== ''">
			      <div class="" style="color: #5CC4AB;">脊柱病史</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.spineHistory != null && medicalInfo.spineHistory !== ''">
			      <div></div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{ medicalInfo.spineHistory }}</div>
			    </div>
			    <div class="liter-title" v-if="medicalInfo.initialResult != null && medicalInfo.initialResult !== ''">
			      <div class="" style="color: #5CC4AB;">初筛结果</div>
			    </div>
			    <div class="report-div-data" v-if="medicalInfo.initialResult != null && medicalInfo.initialResult !== ''">
			      <div></div>
			      <div class="width-400" style="width: 4rem; white-space: pre-line;text-align: left;">{{ medicalInfo.initialResult }}</div>
			    </div>
			  </div>
			</div>
			
			<!-- <div class="report-div" v-if="
                medicalInfo &&
                ((medicalInfo.show5 !== undefined &&
                  medicalInfo.show5 !== null &&
                  medicalInfo.show5 !== '' &&
                  medicalInfo.show5 !== '无侧弯') ||
                  (medicalInfo.show6 !== undefined &&
                    medicalInfo.show6 !== null &&
                    medicalInfo.show6 !== '' &&
                    medicalInfo.show6 !== '无侧弯') ||
                  (medicalInfo.show7 !== undefined &&
                    medicalInfo.show7 !== null &&
                    medicalInfo.show7 !== '' &&
                    medicalInfo.show7 !== '无侧弯') ||
                  (medicalInfo.show8 !== undefined &&
                    medicalInfo.show8 !== null &&
                    medicalInfo.show8 !== '' &&
                    medicalInfo.show8 !== '无侧弯') ||
                  (medicalInfo.show9 !== undefined &&
                    medicalInfo.show9 !== null &&
                    medicalInfo.show9 !== '' &&
                    medicalInfo.show9 !== '无侧弯') ||
                  (medicalInfo.show10 !== undefined &&
                    medicalInfo.show10 !== null &&
                    medicalInfo.show10 !== '' &&
                    medicalInfo.show10 !== '无侧弯') ||
                  (medicalInfo.show11 !== undefined &&
                    medicalInfo.show11 !== null &&
                    medicalInfo.show11 !== '' &&
                    medicalInfo.show11 !== '无侧弯') ||
                  (medicalInfo.show12 !== undefined &&
                    medicalInfo.show12 !== null &&
                    medicalInfo.show12 !== '' &&
                    medicalInfo.show12 !== '无侧弯'))
              ">
              <div class="report-div-title" @click="showJz = !showJz">
                <div>脊柱检查</div>
                <van-icon :name="showJz ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showJz">
                <div class="report-div-data">
                  <div>胸段</div>
                  <div class="width-400">
                    {{
                    medicalInfo.show5 == 0
                    ? "正常"
                    : medicalInfo.show5 == 1
                    ? "侧弯"
                    : medicalInfo.show5
                    }}<span v-if="medicalInfo.show6">{{ medicalInfo.show6 }}度</span>
                    &nbsp;
                  </div>
                </div>
                <div class="report-div-data">
                  <div>腰胸段</div>
                  <div class="width-400">
                    {{
                    medicalInfo.show7 == 0
                    ? "正常"
                    : medicalInfo.show7 == 1
                    ? "侧弯"
                    : medicalInfo.show7
                    }}<span v-if="medicalInfo.show6">{{ medicalInfo.show8 }}度</span>
                    &nbsp;
                  </div>
                </div>
                <div class="report-div-data">
                  <div>腰段</div>
                  <div class="width-400">
                    {{
                    medicalInfo.show9 == 0
                    ? "正常"
                    : medicalInfo.show9 == 1
                    ? "侧弯"
                    : medicalInfo.show9
                    }}<span v-if="medicalInfo.show6">{{ medicalInfo.show10 }}度</span>
                    &nbsp;
                  </div>
                </div>
                <div class="report-div-data">
                  <div>前后弯曲</div>
                  <div class="width-400">
                    {{
                    medicalInfo.show11 == 0
                    ? "正常"
                    : medicalInfo.show11 == 1
                    ? "侧弯"
                    : medicalInfo.show11
                    }}<span v-if="medicalInfo.show6">{{ medicalInfo.show12 }}度</span>
                    &nbsp;
                  </div>
                </div>
                <div class="report-div-tip" v-if="medicalInfo.show2">
                  脊柱检查异常，建议到医院进一步诊治
                </div>
              </div>
            </div>
            -->
			<div class="report-div" v-if="
                medicalInfo &&
                ((medicalInfo.sg !== undefined &&
                  medicalInfo.sg !== null &&
                  medicalInfo.sg !== '') ||
                  (medicalInfo.tz !== undefined &&
                    medicalInfo.tz !== null &&
                    medicalInfo.tz !== '') ||
                  (medicalInfo.xy !== undefined &&
                    medicalInfo.xy !== null &&
                    medicalInfo.xy !== '') ||
                  (medicalInfo.show14 !== undefined &&
                    medicalInfo.show14 !== null &&
                    medicalInfo.show14 !== '') ||
                  (medicalInfo.show16 !== undefined &&
                    medicalInfo.show16 !== null &&
                    medicalInfo.show16 !== '') ||
                  (medicalInfo.show13 !== undefined &&
                    medicalInfo.show13 !== null &&
                    medicalInfo.show13 !== '') ||
                  (medicalInfo.show15 !== undefined &&
                    medicalInfo.show15 !== null &&
                    medicalInfo.show15 !== ''))
              ">
              <div class="report-div-title" @click="showTj = !showTj">
                <div>其他体检</div>
                <van-icon :name="showTj ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showTj">
                <div class="report-div-data-big">
                  <div>
                    身高：{{ medicalInfo.sg ? medicalInfo.sg + "cm" : "---" }}
                  </div>
                  <div>
                    体重：{{ medicalInfo.tz ? medicalInfo.tz + "kg" : "---" }}
                  </div>
                  <div>血压：{{ medicalInfo.xy ? medicalInfo.xy : "---" }}</div>
				  <div>腰围：{{ medicalInfo.waistLine ? medicalInfo.waistLine :'---' }}</div>
                  <div>
                    肺活量：{{
                    medicalInfo.lungAbelSize
                    ? medicalInfo.lungAbelSize
                    : "---"
                    }}
                  </div>
				  <div class="">
				    {{ studentInfo.sex == '男' ? '是否遗精：' : '是否月经：' }}
				    {{ studentInfo.sex == '男' ? medicalInfo.show14 : medicalInfo.show13 }}
				  </div>
				  
				  <div class="">
				    {{ studentInfo.sex == '男' ? '首次遗精年龄：' : '首次月经年龄：' }}{{ studentInfo.sex == '男' ? medicalInfo.show16 :
				    medicalInfo.show15 }}
				  </div>
                </div>
              </div>
			  <div class="report-card" v-if="showTj">
			        <div class="liter-title">
			          <div style="color: #5CC4AB;">疾病史检查报告</div>
					  <!-- <van-icon :name="showJbHistory ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" /> -->
			        </div>
			  	  <!-- 疾病列表 -->
			  	      <div style="padding: 0 0.3rem;" v-if="showJbHistory">
			  			  <div style="font-weight: bold; text-align: left; padding-top: 0.8em; padding-bottom: 0.1rem;color:#333">是否患有以下疾病</div>
			  	        <div v-for="(disease, index) in diseaseData" :key="disease.id" class="disease">
			  	          <!-- 疾病名称（左对齐） -->
			  	          <span class="disease-name">{{ index + 1 }}. {{ disease.name }}</span>
			  	  
			  	          <!-- 选项组（右对齐） -->
			  	          <div class="disease-radio" style="width:1.7rem;justify-content: space-between;">
			  	            <!-- 是 -->
			  	            <div class="disease-radio" style="width:0.7rem;justify-content: space-between;">
			  	              <div  :class="[disease.hasDisease ? 'fa-background' : 'fa-background-disabled']">
			  	                <div class="fa fa-check" ></div>
			  	              </div>
			  	              <span :class="[disease.hasDisease ? '' : 'text-disable']">是</span>
			  	            </div>
			  	  
			  	            <!-- 否 -->
			  	            <div class="disease-radio" style="width:0.7rem;justify-content: space-between;">
			  	              <div :class="[disease.hasDisease ? 'fa-background-disabled' : 'fa-background']">
			  	                <div class="fa fa-check" ></div>
			  	              </div>
			  	              <span :class="[disease.hasDisease ? 'text-disable' : '']">否</span>
			  	            </div>
			  	          </div>
			  	        </div>
			  	      </div>
			    </div>
            </div>
            <div class="report-div" v-if="showDiv[5]">
              <div class="report-div-title" @click="showDipterInfo = !showDipterInfo">
                <div>附：电脑验光检查详细结果</div>
                <van-icon :name="showDipterInfo ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showDipterInfo">
                <div class="report-div-data">
                  <div class="width-160-2"></div>
                  <div class="width-160-2">球镜(S)</div>
                  <div class="width-160-2">柱镜(C)</div>
                  <div sclass="width-160">轴位(A)</div>
                </div>
                <div class="report-div-data">右眼(R)</div>
                <div class="report-div-data">
                  <div class="width-160-1">1</div>
                  <div class="width-160-2">
                    {{ diopterInfo.first_right_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.first_right_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.first_right_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">2</div>
                  <div class="width-160-2">
                    {{ diopterInfo.second_right_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.second_right_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.second_right_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">3</div>
                  <div class="width-160-2">
                    {{ diopterInfo.third_right_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.third_right_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.third_right_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">均值</div>
                  <div class="width-160-2">
                    {{ diopterInfo.avg_right_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.avg_right_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.avg_right_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">S.E</div>
                  <div class="width-400">
                    {{ diopterInfo.right_se | formatFixed2 }}
                  </div>
                </div>
                <div class="report-div-data">左眼(L)</div>
                <div class="report-div-data">
                  <div class="width-160-1">1</div>
                  <div class="width-160-2">
                    {{ diopterInfo.first_left_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.first_left_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.first_right_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">2</div>
                  <div class="width-160-2">
                    {{ diopterInfo.second_left_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.second_left_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.second_left_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">3</div>
                  <div class="width-160-2">
                    {{ diopterInfo.third_left_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.third_left_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.third_left_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">均值</div>
                  <div class="width-160-2">
                    {{ diopterInfo.avg_left_ball | formatFixed2 }}
                  </div>
                  <div class="width-160-2">
                    {{ diopterInfo.avg_left_syl | formatFixed2 }}
                  </div>
                  <div sclass="width-160">
                    {{ diopterInfo.avg_left_axial | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-1">S.E</div>
                  <div class="width-400">
                    {{ diopterInfo.left_se | formatFixed2 }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div class="width-160-2">瞳距(mm)</div>
                  <div class="width-400">{{ diopterInfo.pupilDistance }}</div>
                </div>
              </div>
              <div class="report-div" :style="!showArray[14] ? 'margin-bottom: 0' : ''"
                v-if="otherInfo.rightMlmThickness || otherInfo.leftMlmThickness">
                <div class="report-div-title">脉络膜厚度(微米)</div>
                <div class="report-div-data" v-if="showTr[14]">
                  <div>右眼: {{ otherInfo.rightMlmThickness }}</div>
                  <div>左眼: {{ otherInfo.leftMlmThickness }}</div>
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showArray[1]">
              <div class="report-div-title" @click="showTable(1)">
                <div>裂隙灯</div>
                <van-icon :name="showTr[1] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[1]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightLamp.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftLamp.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                  &nbsp;
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showArray[2]">
              <div class="report-div-title" @click="showTable(2)">
                <div>干眼检查</div>
                <van-icon :name="showTr[2] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[2]">
                <span v-for="(item, index) in otherInfo.dryEye.split(',')" :key="index">
                  <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                </span>
              </div>
            </div>

            <div class="report-div" v-if="showArray[3]">
              <div class="report-div-title" @click="showTable(3)">
                <div>Pentacam</div>
                <van-icon :name="showTr[3] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div></div>
                <div>右眼</div>
                <div>左眼</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div>K1(D)</div>
                <div>{{ otherInfo.pentacamRightK1 | formatVal }}</div>
                <div>{{ otherInfo.pentacamLeftK1 | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div>K2(D)</div>
                <div>{{ otherInfo.pentacamRightK2 | formatVal }}</div>
                <div>{{ otherInfo.pentacamLeftK2 | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div> KM(D)</div>
                <div>{{ otherInfo.pentacamRightKm | formatVal}}</div>
                <div>{{ otherInfo.pentacamLeftKm | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div>Astig</div>
                <div>{{ otherInfo.pentacamRightAstig | formatVal }}</div>
                <div>{{ otherInfo.pentacamLeftAstig | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div>Axial Length</div>
                <div>{{ otherInfo.pentacamRightAxial | formatVal }}</div>
                <div>{{ otherInfo.pentacamLeftAxial | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightPentacam.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftPentacam.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[4]">
              <div class="report-div-title" @click="showTable(4)">
                <div>生物力学</div>
                <van-icon :name="showTr[4] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[4]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightBiologyForce.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftBiologyForce.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[5]">
              <div class="report-div-title" @click="showTable(5)">
                <div>角膜地形图</div>
                <van-icon :name="showTr[5] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>

              <div class="report-div-data" v-if="showTr[5]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(
                        item, index
                      ) in otherInfo.rightBiometricsPicture.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(
                        item, index
                      ) in otherInfo.leftBiometricsPicture.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showArray[6] || showArray[18]">
              <div class="report-div-title" @click="showTable(6, 18)">
                <div>生物测量仪</div>
                <van-icon :name="showTr[6] || showArray[18] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showTr[6] && showArray[6]" class="mrl-30">
                <div class="report-div-title">眼轴</div>
                <div class="report-div-data">
                  <div></div>
                  <div>右眼</div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>眼轴</div>
                  <div>{{ otherInfo.rightAxialLength | formatVal }}</div>
                  <div>{{ otherInfo.leftAxialLength | formatVal }}</div>
                </div>
                <!-- <div class="report-div-data">
                  <div>曲率K1</div>
                  <div>{{ otherInfo.rightEyeCurvatureR1 | formatVal }}</div>
                  <div>{{ otherInfo.leftEyeCurvatureR1 | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>曲率K2</div>
                  <div>{{ otherInfo.rightEyeCurvatureR2 | formatVal }}</div>
                  <div>{{ otherInfo.leftEyeCurvatureR2 | formatVal }}</div>
                </div> -->
                <!-- <div class="report-div-tip">
                  <div style="color: rgb(0, 150, 136)">右眼</div>
                  <div class="mt-20">
                    <div>
                      近视临界点眼轴长度：{{
                      otherInfo.map ? otherInfo.map.rk : ""
                      }}mm
                    </div>
                    <div style="margin-top: 0.15rem">
                      当前屈光度约为：{{
                      otherInfo.map ? otherInfo.map.rqgd : ""
                      }}D(±0.5D)
                    </div>
                    <div style="margin-top: 0.15rem">
                      {{ otherInfo.map ? otherInfo.map.rpdts : "" }}
                    </div>
                  </div>
                  <div style="margin-top: 0.4rem; color: rgb(0, 150, 136)">
                    左眼
                  </div>

                  <div class="mt-20">
                    <div>
                      近视临界点眼轴长度:{{
                      otherInfo.map ? otherInfo.map.lk : ""
                      }}mm
                    </div>
                    <div class="mt-20">
                      当前屈光度约为:{{
                      otherInfo.map ? otherInfo.map.lqgd : ""
                      }}D(±0.5D)
                    </div>
                    <div class="mt-20">
                      {{ otherInfo.map ? otherInfo.map.lpdts : "" }}
                    </div>
                  </div>
                </div>
                <div class="report-div">
                  <div>
                    -为近视，+为远视，此为等效球镜的理论平均值，存在个体差异，数值仅供参考
                  </div>
                  <div>{{ otherInfo.map ? otherInfo.map.lpdts : "" }}</div>
                </div> -->
                <div class="report-div-title">角膜曲率</div>
                <div class="report-div-data">
                  <div></div>
                  <div>右眼</div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>曲率K1/R1</div>
                  <div>{{ otherInfo.rightEyeCurvatureR1 | formatVal }}</div>
                  <div>{{ otherInfo.leftEyeCurvatureR1 | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>曲率K2/R2</div>
                  <div>{{ otherInfo.rightEyeCurvatureR2 | formatVal }}</div>
                  <div>{{ otherInfo.leftEyeCurvatureR2 | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>@轴位1</div>
                  <div>{{ otherInfo.rightAxialView1 | formatVal }}</div>
                  <div>{{ otherInfo.leftAxialView1 | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>@轴位2</div>
                  <div>{{ otherInfo.rightAxialView2 | formatVal }}</div>
                  <div>{{ otherInfo.leftAxialView2 | formatVal }}</div>
                </div>
                <div class="report-div-title">其他参数</div>
                <div class="report-div-data">
                  <div></div>
                  <div>右眼</div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>前房深度</div>
                  <div>{{ otherInfo.rightAcd | formatVal }}</div>
                  <div>{{ otherInfo.leftAcd | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>白到白</div>
                  <div>{{ otherInfo.rightWtw | formatVal }}</div>
                  <div>{{ otherInfo.leftWtw | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>角膜厚度</div>
                  <div>{{ otherInfo.rightCentreCorneaPly | formatVal }}</div>
                  <div>{{ otherInfo.leftCentreCorneaPly | formatVal }}</div>
                </div>
              </div>
              <div class="report-div-data" v-if="showTr[18] && showArray[18]">
                <span v-for="(
                    item, index
                  ) in otherInfo.rightTopographyPicture.split(',')" :key="index">
                  <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                </span>
                &nbsp;
              </div>
            </div>

            <div class="report-div" v-if="showArray[7]">
              <div class="report-div-title" @click="showTable(7)">
                <div>角膜内皮细胞计</div>
                <van-icon :name="showTr[7] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[7]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightXBJ.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftXBJ.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[8]">
              <div class="report-div-title" @click="showTable(8)">
                <div>视野计</div>
                <van-icon :name="showTr[8] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[8]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightPerimeter.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftPerimeter.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[9]">
              <div class="report-div-title" @click="showTable(9)">
                <div>OCT</div>
                <van-icon :name="showTr[9] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div></div>
                <div>右眼</div>
                <div>左眼</div>
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div>脉络膜厚度</div>
                <div>{{ otherInfo.octRightThickness | formatVal }}</div>
                <div>{{ otherInfo.octLeftThickness | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div>平均杯盘比</div>
                <div>{{ otherInfo.octRightAvgRatio | formatVal }}</div>
                <div>{{ otherInfo.octLeftAvgRatio | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div>垂直杯盘比</div>
                <div>{{ otherInfo.octRightVerticalRatio | formatVal}}</div>
                <div>{{ otherInfo.octLeftVerticalRatio | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div>RNFL平均厚度</div>
                <div>{{ otherInfo.octRightAvgThickness | formatVal }}</div>
                <div>{{ otherInfo.octLeftAvgThickness | formatVal }}</div>
              </div>

              <div class="report-div-data" v-if="showTr[9]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightOCT.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftOCT.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[10]">
              <div class="report-div-title" @click="showTable(10)">
                <div>眼底检查</div>
                <van-icon :name="showTr[10] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[10]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightFundusCamera.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftFundusCamera.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[12]">
              <div class="report-div-title" @click="showTable(12)">
                <div>配镜处方</div>
                <van-icon :name="showTr[12] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[12]">
                <div>
                  <span v-for="(item, index) in otherInfo.glassesRecipe.split(',')" :key="index">
                    <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                  </span>
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showArray[13]">
              <div class="report-div-title" @click="showTable(13)">
                <div>AB超</div>
                <van-icon :name="showTr[13] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[13]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightAbchao.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftAbchao.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showArray[11]">
              <div class="report-div-title" @click="showTable(11)">
                <div>其他检查图像</div>
                <van-icon :name="showTr[11] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[11]">
                <div style="display: flex; flex-wrap: wrap; width: 100%">
                  <div style="width: 24%; padding: 3px" v-for="(item, index) in list" :key="index">
                    <img :src="item" @click="goPriview(item)" class="img" @error="defImg" />
                  </div>
                </div>
              </div>
            </div>
            <div class="report-div" style="text-align: left">
              <div style="padding: 0.3rem 0.3rem 0">
                检查机构：{{ csResult.checkName }}
              </div>
              <div style="padding: 0.1rem 0.3rem 0">
                咨询电话：{{ csResult.checkPhone }}
              </div>
              <div class="report-div-tip">
                <div>温馨提示：</div>
                <div>
                  {{
                  csResult && csResult.resultsHint
                  ? csResult.resultsHint
                  : "如遇技术问题或对报告结果有疑问，可扫描页面底部二维码进行咨询"
                  }}
                </div>
                <div style="margin-top: 0.3rem" v-if="
                    diopterInfo.diopterExplain != null &&
                    diopterInfo.diopterExplain != ''
                  ">
                  {{ diopterInfo.diopterExplain }}
                </div>
              </div>
            </div>
          </div>
          <!----------------------------------------------------->

          <!----------------- 眼科门诊检查记录 ---------------------->
          <div v-if="detailTitle == '眼科门诊检查记录'">
            <div class="report-div" style="padding: 0.3rem">
              <div class="report-info">
                <div class="report-info-left">
                  <div>
                    <span>{{ studentInfo.studentName }}</span>
                    <span>{{ studentInfo.sex }} </span>
                    <span>{{ studentInfo.age | formatAge }}</span>
                    <span class="report-info" style="text-align: left">
                      {{ studentInfo.recordDate | formatDate }}
                    </span>
                  </div>
                </div>
                <div class="report-info-right" style="top: -0.3rem">
                  <div @click="goQr()">
                    <i class="van-icon van-icon-qr ewm ewm-big" style="font-size: 1.5rem" />
                  </div>
                </div>
              </div>
            </div>
            <div class="report-div" v-if="
                (studentInfo &&
                (studentInfo.sg ||
                  studentInfo.tz ||
                  studentInfo.bloodSugar ||
                  studentInfo.otherShrinkage ||
                  studentInfo.otherDiastolic ||
                  studentInfo.bmi))
              ">
              <div class="report-div-title" @click="showAllReport = !showAllReport">
                <div>基础检查</div>
                <van-icon :name="showAllReport ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showAllReport">
                <div class="report-div-data">
                  <div>身高：{{ studentInfo.sg || "---" }} cm</div>
                  <div>体重：{{ studentInfo.tz || "---" }} kg</div>
                </div>
                <div class="report-div-data" style="padding-left: 0">
                  <div>血糖：{{ studentInfo.bloodSugar || "---" }}</div>
                  <div>
                    血压：{{ studentInfo.otherShrinkage || "---" }}/{{
                    studentInfo.otherDiastolic || "---"
                    }}
                  </div>
                  <div>BMI：{{ studentInfo.bmi || "---" }}</div>
                </div>
              </div>
            </div>
            <div class="report-div" v-if="
                (visionInfo &&
                (visionInfo.rightNakedeyeVision ||
                  visionInfo.leftNakedeyeVision ||
                  visionInfo.rightGlassesVision ||
                  visionInfo.leftGlassesVision ||
                  visionInfo.glassesType))
              ">
              <div class="report-div-title" @click="showReport = !showReport">
                <div>视力检查报告</div>
                <van-icon :name="showReport ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showReport">
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>

                <div class="report-div-data">
                  <div>
                    {{ visionInfo != null ? visionInfo.rightNakedeyeVision : "---" }}
                  </div>
                  <div>裸眼</div>
                  <div>
                    {{ visionInfo != null ? visionInfo.leftNakedeyeVision : "---" }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div>
                    {{ visionInfo != null ? visionInfo.rightGlassesVision : "---" }}
                  </div>
                  <div>戴镜</div>
                  <div>
                    {{ visionInfo != null ? visionInfo.leftGlassesVision : "---" }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div>戴镜方式</div>
                  <div class="width-400">
                    {{ visionInfo != null ? visionInfo.glassesType : "---" }}
                  </div>
                </div>
                <div v-if="
                  visionInfo != null &&
                  visionInfo.visionExplain != null &&
                  visionInfo.visionExplain != ''
                " class="report-div-tip">
                  {{ visionInfo.visionExplain }}{{ womenStr }}
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showDiv[8]">
              <div class="report-div-title" @click="showAvgInfo = !showAvgInfo">
                <div>非散瞳（电脑）验光</div>
                <van-icon :name="showAvgInfo ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showAvgInfo">
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>球镜(S)</div>
                  <div>{{ diopterInfo.avg_right_ball | formatFixed2 }}</div>
                  <div>{{ diopterInfo.avg_left_ball | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>柱镜(C)</div>
                  <div>{{ diopterInfo.avg_right_syl | formatFixed2 }}</div>
                  <div>{{ diopterInfo.avg_left_syl | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>轴位(A)</div>
                  <div>{{ diopterInfo.avg_right_axial | formatVal }}</div>
                  <div>{{ diopterInfo.avg_left_axial | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>瞳距(mm)</div>
                  <div style="width: 4rem">
                    {{ diopterInfo.pupilDistance | formatVal }}
                  </div>
                </div>
                <div class="report-div-data" v-if="diopterInfo.dlygPicture">
                  <div>验光图片</div>
                  <div style="width: 4rem">
                    <span v-for="(item, index) in diopterInfo.dlygPicture.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>
                <div class="report-div-data">
                  <div>检查日期</div>
                  <div style="width: 4rem">
                    {{ diopterInfo.dlygCheckDate | formatDate }}
                  </div>
                </div>
              </div>

            </div>
            <div class="report-div" v-if="showDiv[6]">
              <div class="report-div-title" @click="showBallInfo = !showBallInfo">
                <div>非散瞳（显然）验光</div>
                <van-icon :name="showBallInfo ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showBallInfo">
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.rightBallZhujue | formatFixed2 }}</div>
                  <div>球镜</div>
                  <div>{{ diopterInfo.leftBallZhujue | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.rightSylZhujue | formatFixed2 }}</div>
                  <div>柱镜</div>
                  <div>{{ diopterInfo.leftSylZhujue | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.rightAxialZhujue | formatVal }}</div>
                  <div>轴位</div>
                  <div>{{ diopterInfo.leftAxialZhujue | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>瞳距</div>
                  <div style="width: 4rem">
                    {{ diopterInfo.xrygPupilDistance | formatVal }}
                  </div>
                </div>
                <div class="report-div-data" v-if="diopterInfo.xrygPicture">
                  <div>验光图片</div>
                  <div style="width: 4rem">
                    <span v-for="(item, index) in diopterInfo.xrygPicture.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>
                <div class="report-div-data">
                  <div>检查日期</div>
                  <div style="width: 4rem">
                    {{ diopterInfo.xrygCheckDate | formatDate }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showDiv[8] || showDiv[6]" class="report-div">
              <div class="report-div-tip">
                <div v-if="diopterInfo.diopterExplain" class="mb-30">
                  <p>{{ diopterInfo.diopterExplain }}</p>
                </div>
                <div>
                  <p>注：</p>
                  <p>1 .“球镜”为近视或远视度数，负值“-”为近视，正值为远视；</p>
                  <p>
                    2
                    .“柱镜”为散光度数；轴位为散光的方向，有散光度数才会有散光轴位。
                  </p>
                  <p>
                    3
                    .电脑验光检查报告为初筛数据，仅作为医生参考，不作为诊断结果，不能直接作为配镜处方。
                  </p>
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showDiv[7]">
              <div class="report-div-title" @click="showBallAvg = !showBallAvg">
                <div>非散瞳（显然）验光</div>
                <van-icon :name="showBallAvg ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showBallAvg">
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.rightBallAvgAfter | formatFixed2 }}</div>
                  <div>球镜</div>
                  <div>{{ diopterInfo.leftBallAvgAfter | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.rightSylAvgAfter | formatFixed2 }}</div>
                  <div>柱镜</div>
                  <div>{{ diopterInfo.leftSylAvgAfter | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.rightAxialAvgAfter | formatVal }}</div>
                  <div>轴位</div>
                  <div>{{ diopterInfo.leftAxialAvgAfter | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>瞳距</div>
                  <div style="width: 4rem">
                    {{ diopterInfo.pupilDistanceAfter | formatVal }}
                  </div>
                </div>
                <div class="report-div-data">
                  <div>验光图片</div>
                  <div style="width: 4rem" v-if="diopterInfo.dlygsthPicture">
                    <span v-for="(item, index) in diopterInfo.dlygsthPicture.split(
                      ','
                    )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>
                <div class="report-div-data">
                  <div>检查日期</div>
                  <div style="width: 4rem">
                    {{ diopterInfo.dlygsthCheckDate | formatDate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showDiv[9]">
              <div class="report-div-title" @click="showBallChapian = !showBallChapian">
                <div>散瞳（显然）验光</div>
                <van-icon :name="showBallChapian ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showBallChapian">
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.rightBallChaPian | formatFixed2 }}</div>
                  <div>球镜</div>
                  <div>{{ diopterInfo.leftBallChaPian | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.rightSylChaPian | formatFixed2 }}</div>
                  <div>柱镜</div>
                  <div>{{ diopterInfo.leftSylChaPian | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.rightAxialChaPian | formatVal }}</div>
                  <div>轴位</div>
                  <div>{{ diopterInfo.leftAxialChaPian | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>矫正视力</div>
                  <div>{{ diopterInfo.rightCorrectChaPian | formatFixed2 }}</div>
                  <div>{{ diopterInfo.leftCorrectChaPian | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>瞳距</div>
                  <div style="width: 4rem">
                    {{ diopterInfo.xrygsthPupilDistance | formatVal }}
                  </div>
                </div>
                <div class="report-div-data" v-if="diopterInfo.xrygsthPicture">
                  <div>验光图片</div>
                  <div style="width: 4rem">
                    <span v-for="(item, index) in diopterInfo.xrygsthPicture.split(
                      ','
                    )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>

                <div class="report-div-data">
                  <div>检查日期</div>
                  <div style="width: 4rem">
                    {{ diopterInfo.xrygsthCheckDate | formatDate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showDiv[13]">
              <div class="report-div-title" @click="showBallAvg1 = !showBallAvg1">
                <div>复验（电脑）验光</div>
                <van-icon :name="showBallAvg1 ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>

              <div v-if="showBallAvg1">
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.rightBallAvgAfter1 | formatFixed2 }}</div>
                  <div>球镜</div>
                  <div>{{ diopterInfo.leftBallAvgAfter1 | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.rightSylAvgAfter1 | formatFixed2 }}</div>
                  <div>柱镜</div>
                  <div>{{ diopterInfo.leftSylAvgAfter1 | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ diopterInfo.rightAxialAvgAfter1 | formatVal }}</div>
                  <div>轴位</div>
                  <div>{{ diopterInfo.leftAxialAvgAfter1 | formatVal }}</div>
                </div>

                <div class="report-div-data">
                  <div>瞳距</div>
                  <div style="width: 4rem">
                    {{ diopterInfo.pupilDistanceAfter1 | formatVal }}
                  </div>
                </div>
                <div class="report-div-data" v-if="diopterInfo.dlygfyPicture">
                  <div>验光图片</div>
                  <div style="width: 4rem">
                    <span v-for="(item, index) in diopterInfo.dlygfyPicture.split(
                      ','
                    )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>
                <div class="report-div-data">
                  <div>检查日期</div>
                  <div style="width: 4rem">
                    {{ diopterInfo.dlygfyCheckDate | formatDate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showDiv[10]">
              <div class="report-div-title" @click="showBallZhujue = !showBallZhujue">
                <div>复验（显然）验光</div>
                <van-icon :name="showBallZhujue ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showBallZhujue">
                <div class="report-div-data">
                  <div></div>
                  <div>右眼</div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>球镜</div>
                  <div>{{ diopterInfo.rightBallZhujue_1 | formatFixed2 }}</div>
                  <div>{{ diopterInfo.leftBallZhujue_1 | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>柱镜</div>
                  <div>{{ diopterInfo.rightSylZhujue_1 | formatFixed2 }}</div>
                  <div>{{ diopterInfo.leftSylZhujue_1 | formatFixed2 }}</div>
                </div>
                <div class="report-div-data">
                  <div>轴位</div>
                  <div>{{ diopterInfo.rightAxialZhujue_1 | formatVal }}</div>
                  <div>{{ diopterInfo.leftAxialZhujue_1 | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>瞳距</div>
                  <div style="width: 4rem">
                    {{ diopterInfo.xrygfyPupilDistance | formatVal }}
                  </div>
                </div>
                <div class="report-div-data" v-if="diopterInfo.xrygfyPicture">
                  <div>验光图片</div>
                  <div style="width: 4rem">
                    <span v-for="(item, index) in diopterInfo.xrygfyPicture.split(
                      ','
                    )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>

                <div class="report-div-data">
                  <div>检查日期</div>
                  <div style="width: 4rem">
                    {{ diopterInfo.xrygfyCheckDate | formatDate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showDiv[14]">
              <div class="report-div-title" @click="showPress = !showPress">
                <div>眼压检查</div>
                <van-icon :name="showPress ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showPress">
                <div class="report-div-data">
                  <div>右眼: {{ otherInfo.rightEyePressure | formatVal }}</div>
                  <div>左眼: {{ otherInfo.leftEyePressure | formatVal }}</div>
                </div>
              </div>
            </div>

            <div class="report-div report-div-visual" v-if="showDiv[12]">
              <div class="report-div-title" @click="showVisualFunction = !showVisualFunction">
                <div>视功能检查</div>
                <van-icon :name="showVisualFunction ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showVisualFunction">
                <div class="report-div-data-2 report-div-data-2-visual">
                  <div class="base">
                    <div class="label-title">主导眼</div>
                    <div class="">{{ visualFunctionInfo.dominant | formatVal }}</div>
                  </div>
                  <div class="base">
                    <div class="label-title">调节近点</div>
                    <div class="">{{ visualFunctionInfo.accNear | formatVal }}</div>
                  </div>
                </div>
                <div class="report-div-data-2 report-div-data-2-visual">
                  <div class="base">
                    <div class="label-title">同时视</div>
                    <div class="">{{ visualFunctionInfo.simult | formatVal }}</div>
                  </div>
                  <div class="base">
                    <div class="label-title">Worth4点灯(远)</div>
                    <div class="">{{ visualFunctionInfo.fusion | formatVal }}  {{ visualFunctionInfo.fusion && visualFunctionInfo.fusion=='其他'?visualFunctionInfo.fusionTxt : '' }}</div>
                  </div>
                  
                </div>
                <div class="report-div-data-2 report-div-data-2-visual">
                  <div class="base">
                    <div class="label-title">立体视(近)</div>
                    <div class="">{{ visualFunctionInfo.stereopsis | formatVal }}</div>
                  </div>

                  <div class="base">
                    <div class="label-title">立体视(远)</div>
                    <div class="">{{ visualFunctionInfo.stereopsisFar | formatVal }} {{visualFunctionInfo.stereopsisFar &&visualFunctionInfo.stereopsisFar=='其他'?visualFunctionInfo.stereopsisFarTxt : ''}}</div>
                  </div>
                </div>
                <div class="report-div-data-2 report-div-data-2-visual">
                  <div class="base">
                    <div class="label-title">远水平隐斜</div>
                    <div class="">{{ visualFunctionInfo.farDeviation | formatVal }}</div>
                  </div>
                  <div class="base">
                    <div class="label-title">近水平隐斜</div>
                    <div class="">{{ visualFunctionInfo.nearDeviation | formatVal }}</div>
                  </div>
                </div>
                <div class="report-div-data-2 report-div-data-2-visual">
                  <div class="base">
                    <div class="label-title">远垂直隐斜</div>
                    <div class="">{{ visualFunctionInfo.farVerticalDeviation | formatVal }}</div>
                  </div>
                  <div class="base">
                    <div class="label-title">近垂直隐斜</div>
                    <div class="">{{ visualFunctionInfo.nearVerticalDeviation | formatVal }}</div>
                  </div>
                </div>
                <div class="report-div-data-2 report-div-data-2-visual">
                  <div class="base">
                    <div class="label-title">+1D近水平隐斜</div>
                    <div class="">{{ visualFunctionInfo.straightNearDeviation | formatVal }}</div>
                  </div>
                  <div class="base">
                    <div class="label-title">-1D近水平隐斜</div>
                    <div class="">{{ visualFunctionInfo.burdenNearDeviation | formatVal }}</div>
                  </div>
                </div>
                <div class="report-div-data-2 report-div-data-2-visual">
                  <div class="base">
                    <div class="label-title">AC/A</div>
                    <div class="">{{ visualFunctionInfo.aca | formatVal }}</div>
                  </div>
                  <div class="base">
                    <div class="label-title">负相对调节</div>
                    <div class="">{{ visualFunctionInfo.minusRelative | formatVal }}</div>
                  </div>
                </div>
                <div class="report-div-data-2 report-div-data-2-visual">
                  <div class="base">
                    <div class="label-title">正相对调节</div>
                    <div class="">{{ visualFunctionInfo.plusRelative | formatVal }}</div>
                  </div>
                  <div class="base">
                    <div class="label-title">调节反应</div>
                    <div class="">{{ visualFunctionInfo.accReaction | formatVal }}</div>
                  </div>
                </div>
                <div class="report-div-data-2 report-div-data-2-visual">
                  <div class="base">
                    <div class="label-title">集合近点</div>
                    <div class="">{{ visualFunctionInfo.conNear | formatVal }}</div>
                  </div>
                  <div class="base">
                    <div class="label-title">远水平融像NRV</div>
                    <div class="">{{ visualFunctionInfo.farImagePlus | formatVal }}</div>
                  </div>
                </div>
                <div class="report-div-data-2 report-div-data-2-visual">
                  <div class="base">
                    <div class="label-title">近水平融像NRV</div>
                    <div class="">{{ visualFunctionInfo.nearImagePlus | formatVal }}</div>
                  </div>
                  <div class="base">
                    <div class="label-title">近水平融像PRV</div>
                    <div class="">{{ visualFunctionInfo.nearImageMinus | formatVal }}</div>
                  </div>
                </div>
                <div class="report-div-data-2 report-div-data-2-visual">
                  <div class="base">
                    <div class="label-title">远水平融像PRV</div>
                    <div class="">{{ visualFunctionInfo.farImageMinus | formatVal }}</div>
                  </div>

                  <!-- <div class="width-4-3"></div>
                  <div class="width-4-4"></div> -->
                </div>
              </div>

            </div>

            <div class="report-div" v-if="showDiv[16]">
              <div class="report-div-title" @click="showRange = !showRange">
                <div>调节幅度</div>
                <van-icon :name="showRange ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showRange">
                <div class="report-div-data">
                  <div style="width: 33.33%">
                    双眼：{{ visualFunctionInfo.eyesRange | formatVal }}
                  </div>
                  <div style="width: 33.33%">
                    右眼：{{ visualFunctionInfo.rightRange | formatVal }}
                  </div>
                  <div style="width: 33.33%">
                    左眼：{{ visualFunctionInfo.leftRange | formatVal }}
                  </div>
                </div>
              </div>
            </div>
            
            <div class="report-div" v-if="showDiv[15]">
              <div class="report-div-title" @click="showSensitive = !showSensitive">
                <div>调节灵敏度</div>
                <van-icon :name="showSensitive ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showSensitive">
                <div class="report-div-data">
                  <div style="width: 33.33%">
                    双眼：{{ visualFunctionInfo.eyesSensitive | formatVal }}
                  </div>
                  <div style="width: 33.33%">
                    右眼：{{ visualFunctionInfo.rightSensitive | formatVal }}
                  </div>
                  <div style="width: 33.33%">
                    左眼：{{ visualFunctionInfo.leftSensitive | formatVal }}
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showDiv[17]">
              <div class="report-div-title" @click="showFunctionPicture = !showFunctionPicture">
                <div>视功能图片</div>
                <van-icon :name="showFunctionPicture ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div v-if="showFunctionPicture">
                <div class="report-div-data">
                  <span v-for="(item, index) in visualFunctionInfo.visualFunctionPicture.split(',')" :key="index">
                    <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                  </span>
                </div>
              </div>
              <div class="report-div" v-if="
                vsualSenseInfo != null &&
                vsualSenseInfo.stringBuilder != null &&
                vsualSenseInfo.stringBuilder != ''
              ">
                <div class="report-div-title">视觉检查</div>
                <div class="report-div-data">
                  异常项目：{{ vsualSenseInfo.stringBuilder | formatVal }}
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[1]">
              <div class="report-div-title" @click="showTr[1] = !showTr[1]">
                <div>裂隙灯</div>
                <van-icon :name="showTr[1] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>

              <div class="report-div-data" v-if="showTr[1]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightLamp.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftLamp.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                  &nbsp;
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showArray[2]">
              <div class="report-div-title" @click="showTr[2] = !showTr[2]">
                <div>干眼检查</div>
                <van-icon :name="showTr[2] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[2]">
                <div>右眼</div>
                <div></div>
                <div>左眼</div>
              </div>
              <div class="report-div-data" v-if="showTr[2]">
                <div>{{ ganYanMap.rightRiverTears }}</div>
                <div>泪河高度</div>
                <div>{{ ganYanMap.leftRiverTears }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[2]">
                <div>{{ ganYanMap.rightEyeGlands | formatGy }}</div>
                <div>睑板腺分析</div>
                <div>{{ ganYanMap.leftEyeGlands | formatGy }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[2]">
                <div>{{ ganYanMap.rightBut }}</div>
                <div>泪膜破裂时间(BUT)</div>
                <div>{{ ganYanMap.leftBut }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[2]">
                <div>{{ ganYanMap.rightEyeRed }}</div>
                <div>眼红分析</div>
                <div>{{ ganYanMap.leftEyeRed }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[2]">
                <div>{{ ganYanMap.rightFatThick }}</div>
                <div>脂质层厚度(LLT)</div>
                <div>{{ ganYanMap.leftFatThick }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[2]">
                <span v-for="(item, index) in otherInfo.dryEye.split(',')" :key="index">
                  <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                </span>
              </div>
            </div>

            <div class="report-div" v-if="showArray[3]">
              <div class="report-div-title" @click="showTable(3)">
                <div>Pentacam</div>
                <van-icon :name="showTr[3] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div></div>
                <div>右眼</div>
                <div>左眼</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div>K1(D)</div>
                <div>{{ otherInfo.pentacamRightK1 | formatVal }}</div>
                <div>{{ otherInfo.pentacamLeftK1 | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div>K2(D)</div>
                <div>{{ otherInfo.pentacamRightK2 | formatVal }}</div>
                <div>{{ otherInfo.pentacamLeftK2 | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div> KM(D)</div>
                <div>{{ otherInfo.pentacamRightKm | formatVal}}</div>
                <div>{{ otherInfo.pentacamLeftKm | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div>Astig</div>
                <div>{{ otherInfo.pentacamRightAstig | formatVal }}</div>
                <div>{{ otherInfo.pentacamLeftAstig | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div>Axial Length</div>
                <div>{{ otherInfo.pentacamRightAxial | formatVal }}</div>
                <div>{{ otherInfo.pentacamLeftAxial | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[3]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightPentacam.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftPentacam.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[4]">
              <div class="report-div-title" @click="showTable(4)">
                <div>生物力学</div>
                <van-icon :name="showTr[4] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[4]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightBiologyForce.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftBiologyForce.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[5]">
              <div class="report-div-title" @click="showTable(5)">
                <div>角膜地形图</div>
                <van-icon :name="showTr[5] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[5]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(
                        item, index
                      ) in otherInfo.rightBiometricsPicture.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(
                        item, index
                      ) in otherInfo.leftBiometricsPicture.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <!--div class="report-content">备注:{{studentInfo.topographyPictureTxt | formatVal}}</div -->
              </div>
            </div>
            <div class="report-div" v-if="showArray[6] || showArray[18]">
              <div class="report-div-title" @click="showTable(6, 18)">
                <div>生物测量仪</div>
                <van-icon :name="showTr[6] || showTr[18] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>

              <div v-if="showTr[6] && showArray[6]" class="mrl-30">
                <div class="report-div-title">眼轴</div>
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightAxialLength | formatVal }}</div>
                  <div>眼轴</div>
                  <div>{{ otherInfo.leftAxialLength | formatVal }}</div>
                </div>
                <!-- <div class="report-div-data">
                  <div>{{ otherInfo.rightEyeCurvatureR1 | formatVal }}</div>
                  <div>曲率K1</div>
                  <div>{{ otherInfo.leftEyeCurvatureR1 | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightEyeCurvatureR2 | formatVal }}</div>
                  <div>曲率K2</div>
                  <div>{{ otherInfo.leftEyeCurvatureR2 | formatVal }}</div>
                </div> -->
                <!-- <div class="report-div-tip">
                  <div style="color: rgb(0, 150, 136)">右眼</div>
                  <div class="mt-20">
                    <div>
                      近视临界点眼轴长度：{{
                      otherInfo.map ? otherInfo.map.rk : "---"
                      }}mm
                    </div>
                    <div style="margin-top: 0.15rem">
                      当前屈光度约为：{{
                      otherInfo.map ? otherInfo.map.rqgd : ""
                      }}D(±0.5D)
                    </div>
                    <div style="margin-top: 0.15rem">
                      {{ otherInfo.map ? otherInfo.map.rpdts : "---" }}
                    </div>
                  </div>
                  <div style="margin-top: 0.4rem; color: rgb(0, 150, 136)">
                    左眼
                  </div>

                  <div class="mt-20">
                    <div>
                      近视临界点眼轴长度:{{
                      otherInfo.map ? otherInfo.map.lk : "---"
                      }}mm
                    </div>
                    <div class="mt-20">
                      当前屈光度约为:{{
                      otherInfo.map ? otherInfo.map.lqgd : ""
                      }}D(±0.5D)
                    </div>
                    <div class="mt-20">
                      {{ otherInfo.map ? otherInfo.map.lpdts : "---" }}
                    </div>
                  </div>
                </div>
                <div class="report-div-tip">
                  <div>
                    -为近视，+为远视，此为等效球镜的理论平均值，存在个体差异，数值仅供参考
                  </div>
                  <div>{{ otherInfo.map ? otherInfo.map.lpdts : "" }}</div>
                </div> -->
                <div class="report-div-title">角膜曲率</div>
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightEyeCurvatureR1 | formatVal }}</div>
                  <div> 曲率K1/R1</div>
                  <div>{{ otherInfo.leftEyeCurvatureR1 | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightEyeCurvatureR2 | formatVal }}</div>
                  <div>曲率K2/R2</div>
                  <div>{{ otherInfo.leftEyeCurvatureR2 | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightAxialView1 | formatVal }}</div>
                  <div>@轴位1</div>
                  <div>{{ otherInfo.leftAxialView1 | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightAxialView2 | formatVal }}</div>
                  <div>@轴位2</div>
                  <div>{{ otherInfo.leftAxialView2 | formatVal }}</div>
                </div>
                <div class="report-div-title">其他参数</div>
                <div class="report-div-data">
                  <div>右眼</div>
                  <div></div>
                  <div>左眼</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightAcd | formatVal }}</div>
                  <div>前房深度</div>
                  <div>{{ otherInfo.leftAcd | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightWtw | formatVal }}</div>
                  <div>白到白</div>
                  <div>{{ otherInfo.leftWtw | formatVal }}</div>
                </div>
                <div class="report-div-data">
                  <div>{{ otherInfo.rightCentreCorneaPly | formatVal }}</div>
                  <div>角膜厚度</div>
                  <div>{{ otherInfo.leftCentreCorneaPly | formatVal }}</div>
                </div>
              </div>

              <div class="report-div-data" v-if="showTr[18] && showArray[18]">
                <span v-for="(
                    item, index
                  ) in otherInfo.rightTopographyPicture.split(',')" :key="index">
                  <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                </span>
              </div>
            </div>

            <div class="report-div" v-if="showArray[7]">
              <div class="report-div-title" @click="showTable(7)">
                <div>角膜内皮细胞计</div>
                <van-icon :name="showTr[7] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[7]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightXBJ.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftXBJ.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[8]">
              <div class="report-div-title" @click="showTable(8)">
                <div>视野计</div>
                <van-icon :name="showTr[8] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[8]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightPerimeter.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftPerimeter.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                  <!-- div class="report-content">备注:{{studentInfo.rightPerimeterTxt | formatVal}}</div -->
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[9]">
              <div class="report-div-title" @click="showTable(9)">
                <div>OCT</div>
                <van-icon :name="showTr[9] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div></div>
                <div>右眼</div>
                <div>左眼</div>
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div>脉络膜厚度</div>
                <div>{{ otherInfo.octRightThickness | formatVal }}</div>
                <div>{{ otherInfo.octLeftThickness | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div>平均杯盘比</div>
                <div>{{ otherInfo.octRightAvgRatio | formatVal }}</div>
                <div>{{ otherInfo.octLeftAvgRatio | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div>垂直杯盘比</div>
                <div>{{ otherInfo.octRightVerticalRatio | formatVal}}</div>
                <div>{{ otherInfo.octLeftVerticalRatio | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div>RNFL平均厚度</div>
                <div>{{ otherInfo.octRightAvgThickness | formatVal }}</div>
                <div>{{ otherInfo.octLeftAvgThickness | formatVal }}</div>
              </div>
              <div class="report-div-data" v-if="showTr[9]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightOCT.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftOCT.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[10]">
              <div class="report-div-title" @click="showTable(10)">
                <div>眼底检查</div>
                <van-icon :name="showTr[10] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[10]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightFundusCamera.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftFundusCamera.split(
                        ','
                      )" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>

            <div class="report-div" v-if="showArray[12]">
              <div class="report-div-title" @click="showTable(12)">
                <div>配镜处方</div>
                <van-icon :name="showTr[12] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[12]">
                <span v-for="(item, index) in otherInfo.glassesRecipe.split(',')" :key="index">
                  <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                </span>
              </div>
            </div>

            <div class="report-div" v-if="showArray[13]">
              <div class="report-div-title" @click="showTable(13)">
                <div>AB超</div>
                <van-icon :name="showTr[13] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[13]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.rightAbchao.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(item, index) in otherInfo.leftAbchao.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
            <div class="report-div" v-if="showArray[11]">
              <div class="report-div-title" @click="showTable(11)">
                <div>其他检查图像</div>
                <van-icon :name="showTr[11] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[11]">
                <div style="display: flex; flex-wrap: wrap; width: 100%">
                  <div style="width: 24%; padding: 3px" v-for="(item, index) in list" :key="index">
                    <img :src="item" @click="goPriview(item)" class="img" @error="defImg" />
                  </div>
                </div>
              </div>
            </div>
            <!--TODO 加一个干眼表格出来-->
            <div class="report-div" v-if="showArray[16]">
              <div class="report-div-title" @click="showTable(16)">
                <div>干眼报告</div>
                <van-icon :name="showTr[16] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="form-modal" ref="print" v-if="showTr[16]">
                <h1 style="text-align: center" class="text-bold">
                  首都医科大学附属北京同仁医院
                </h1>
                <div class="img-wrap">
                  <img src="~@/assets/tongren_logo.png" />
                </div>
                <h2 class="title text-bold">干眼检查综合报告单</h2>
                <div ref="form" style="margin: 0 0.15rem">
                  <table cellspacing="0" cellpadding="0" class="form-table">
                    <tr>
                      <td class="td-col-6-1">
                        <div class="align-center">
                          姓名：
                          <div>{{ model.studentName }}</div>
                        </div>
                      </td>
                      <td class="td-col-6-1">
                        <div class="align-center">
                          性别：
                          <div>{{ model.studentSexText }}</div>
                        </div>
                      </td>
                      <!-- <a-radio-group v-model="model.sex" :readOnly="type">
                            <a-radio v-for="(item, index) in sexOptions" :key="item.value" :value="item.value">{{ item.label }}</a-radio>
                          </a-radio-group> -->
                      <td class="td-col-6">
                        <div class="align-center">
                          年龄：
                          <div>{{ model.studentAge }}</div>
                          岁
                        </div>
                      </td>
                      <td class="td-col-6">
                        <div class="align-center">
                          病历号：
                          <div>{{ model.data_id }}</div>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <table cellspacing="0" cellpadding="0" class="form-table">
                    <tr class="text-center text-bold">
                      <td class="td-col-12">检查内容</td>
                      <td class="td-col-6">右眼（OD）</td>
                      <td class="td-col-6">左眼（OS）</td>
                    </tr>
                    <tr>
                      <td class="exam-name">
                        <div class="text-bold">OSDI问卷</div>
                        <div class="text-light">正常值：&gt; 13分</div>
                      </td>
                      <td>
                        <div class="align-center">
                          <div class="edit-input">{{ model.right_osdi }}</div>
                        </div>
                      </td>
                      <td>
                        <div class="align-center">
                          <div class="edit-input">{{ model.left_osdi }}</div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="exam-name">
                        <div class="text-bold">泪河高度(TMH)</div>
                        <div class="text-light">正常值：≥0.20mm</div>
                      </td>
                      <td>
                        <div class="align-center">
                          TMH：
                          <div class="edit-input">{{ model.right_tmh }}</div>
                          mm
                        </div>
                      </td>
                      <td>
                        <div class="align-center">
                          TMH：
                          <div class="edit-input">{{ model.left_tmh }}</div>
                          mm
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td rowspan="3" class="exam-name">
                        <div class="text-bold">非接触泪膜破裂时间 (NIKBUT)</div>
                        <div class="text-light">
                          <div>
                            0级 正常：首次破裂时间：≥10s: 平均破裂时间：≥14s
                          </div>
                          <div>
                            1级 可疑：首次破裂时间：6-9s: 平均破裂时间：8-13s
                          </div>
                          <div>
                            2级 干眼：首次破裂时间：≤5s: 平均破裂时间：≤7s
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="align-center">
                          首次破裂时间：
                          <div class="edit-input">
                            {{ model.right_first_but }}
                          </div>
                          s
                        </div>
                      </td>
                      <td>
                        <div class="align-center">
                          首次破裂时间：
                          <div class="edit-input">
                            {{ model.left_first_but }}
                          </div>
                          s
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="align-center">
                          平均破裂时间：
                          <div class="edit-input">
                            {{ model.right_avg_but }}
                          </div>
                          s
                        </div>
                      </td>
                      <td>
                        <div class="align-center">
                          平均破裂时间：
                          <div class="edit-input">{{ model.left_avg_but }}</div>
                          s
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="align-center">
                          分级：
                          <div class="edit-input">
                            {{ model.right_but_grade }}
                          </div>
                          级
                        </div>
                      </td>
                      <td>
                        <div class="align-center">
                          分级：
                          <div class="edit-input">
                            {{ model.left_but_grade }}
                          </div>
                          级
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td rowspan="2" class="exam-name">
                        <div class="text-bold">睑板腺图像分析(Meibo-Scan)</div>
                        <div class="text-light">
                          <div>0级：无缺失</div>
                          <div>1级：缺失面积 &lt;1/3</div>
                          <div>2级：缺失面积 1/3~2/3</div>
                          <div>3级：缺失面积 >2/3</div>
                        </div>
                      </td>
                      <td>
                        <div class="align-center">
                          上睑：
                          <div class="edit-input">
                            {{ model.right_upper_scan }}
                          </div>
                          级
                        </div>
                      </td>
                      <td>
                        <div class="align-center">
                          上睑：
                          <div class="edit-input">
                            {{ model.left_upper_scan }}
                          </div>
                          级
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="align-center">
                          下睑：
                          <div class="edit-input">
                            {{ model.right_down_scan }}
                          </div>
                          级
                        </div>
                      </td>
                      <td>
                        <div class="align-center">
                          下睑：
                          <div class="edit-input">
                            {{ model.left_down_scan }}
                          </div>
                          级
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="exam-name">
                        <div class="text-bold">
                          泪膜脂质层厚度(LLT，0~100nm)
                        </div>
                        <div class="text-light">正常值：≥60nm</div>
                      </td>
                      <td>
                        <div class="align-center">
                          LLT：
                          <div class="edit-input">{{ model.right_llt }}</div>
                          nm
                        </div>
                      </td>
                      <td>
                        <div class="align-center">
                          LLT：
                          <div class="edit-input">{{ model.left_llt }}</div>
                          nm
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="text-bold">
                          不完全瞬目 (Partial Blinking )
                        </div>
                      </td>
                      <td>
                        <div class="align-center" style="margin-bottom: 4px">
                          不完全瞬目：
                          <div class="edit-input">
                            {{ model.right_blink_not_count }}
                          </div>
                          次
                        </div>
                        <div class="align-center">
                          总瞬目：
                          <div class="edit-input">
                            {{ model.right_blink_count }}
                          </div>
                          次
                        </div>
                      </td>
                      <td>
                        <div class="align-center" style="margin-bottom: 4px">
                          不完全瞬目：
                          <div class="edit-input">
                            {{ model.left_blink_not_count }}
                          </div>
                          次
                        </div>
                        <div class="align-center">
                          总瞬目：
                          <div class="edit-input">
                            {{ model.left_blink_count }}
                          </div>
                          次
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="exam-name">
                        <div class="text-bold">荧光素泪膜破裂时间（FBUT）</div>
                        <div class="text-light">正常值：>10 s</div>
                      </td>
                      <td>
                        <div class="align-center">
                          <div class="edit-input">{{ model.right_but }}</div>
                          s
                        </div>
                      </td>
                      <td>
                        <div class="align-center">
                          <div class="edit-input">{{ model.left_but }}</div>
                          s
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td rowspan="2" class="exam-name">
                        <div class="text-bold">
                          角膜荧光染色 (NEI评分，0~15分)
                        </div>
                        <div class="text-light">
                          角膜分为5个象限，每个象限0~3分
                        </div>
                        <div>
                          <img style="width: 40%; margin-left: 30px" src="~@/assets/tongren_fenshu.png" />
                        </div>
                        <!--<div>1分:着染1-30个点</div>
                          <div>2分:着染>30个点但无融合</div>
                          <div>3分:着染融合、丝状物、溃病等</div> -->
                      </td>
                      <td>
                        <div class="align-center">
                          评分：
                          <div class="edit-input">
                            {{ model.right_corneal_staining }}
                          </div>
                          分
                        </div>
                      </td>
                      <td>
                        <div class="align-center">
                          评分：
                          <div class="edit-input">
                            {{ model.left_corneal_staining }}
                          </div>
                          分
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="align-center" style="justify-content: center">
                          <img style="width: 62px" src="~@/assets/tongren_yuan.jpg" />
                        </div>
                      </td>
                      <td>
                        <div class="align-center" style="justify-content: center">
                          <img style="width: 62px" src="~@/assets/tongren_yuan.jpg" />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="exam-name">
                        <div class="text-bold">
                          泪液分泌试验 (Schirmer Ⅰ) ：
                        </div>
                        <div class="text-light">正常值：>10mm</div>
                      </td>
                      <td>
                        <div class="align-center">
                          SchirmerⅠ：
                          <div class="edit-input">
                            {{ model.right_schirmer }}
                          </div>
                          mm
                        </div>
                      </td>
                      <td>
                        <div class="align-center">
                          SchirmerⅠ：
                          <div class="edit-input">
                            {{ model.left_schirmer }}
                          </div>
                          mm
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div class="bottom text-bold" style="padding-bottom: 1rem;">
                    <div class="div_left">检查人：</div>
                    <div class="div_right">
                      日期： <span class="space"></span> 年
                      <span class="space"></span>月
                      <span class="space"></span>日
                    </div>
                  </div>
                </div>
                <!-- </a-spin> -->
              </div>
            </div>

            <div class="report-div" v-if="showArray[17]">
              <div class="report-div-title" @click="showTable(17)">
                <div>干眼图片</div>
                <van-icon :name="showTr[17] ? 'arrow-down' : 'arrow-up'" size="15px" class="mt-20" />
              </div>
              <div class="report-div-data" v-if="showTr[17]">
                <div class="width-50">
                  <div class="height-50">右眼</div>
                  <div>
                    <span v-for="(
                        item, index
                      ) in otherInfo.rightBiometricsPicture.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div class="width-50">
                  <div class="height-50">左眼</div>
                  <div>
                    <span v-for="(
                        item, index
                      ) in otherInfo.leftBiometricsPicture.split(',')" :key="index">
                      <img :src="item" @error="defImg" @click="goPriview(item)" class="img" />
                    </span>
                    &nbsp;
                  </div>
                </div>
                <!--div class="report-content">备注:{{studentInfo.topographyPictureTxt | formatVal}}</div -->
              </div>
            </div>
          </div>
          <!---------------------------------------------------------->

          <div style="padding: 0.3rem; text-align: center; vertical-align: middle; background: #fff; 
		  display: flex;flex-direction: column;justify-content: center;min-height: 45vh;">
			<div style="color:rgb(0, 150, 136);display: flex;flex-direction: column; align-items: center;gap:0.5em;
			     padding: 0 0px 0.3rem;
			     min-height: 74vh;justify-content: center;
			     box-sizing: border-box;" v-if="detailTitle != '筛查结果报告' && showNoInfoMsg">
				<img src='../../assets/img/docMiss.svg' style="width: 1rem"/>
				暂无检查数据
			</div>
			<div style="border-top: 1px solid rgb(0, 150, 136);" v-if="detailTitle != '筛查结果报告' && showNoInfoMsg && customerUrl != null && customerUrl != ''"></div>
			<div v-if="customerUrl != null && customerUrl != ''" >
				<img :src="customerUrl" style="width: 6rem; margin: 0.3rem auto" />
				<div style="margin: 0.2rem auto; font-size: 0.3rem">
				  如对筛查结果有疑问，可长按识别二维码，立即咨询
				</div>
			</div>
          </div>

          <div style="padding: 0.3rem" v-if="customerUrl == null || customerUrl == ''"></div>
        </div>
        <div v-if="item.name == '视光曲线'">
          <div class="echart-list">
            <div :class="lineActive === 0 ? 'echart-item active' : 'echart-item'" @click="changeLine(0)">
              视力曲线
            </div>
            <div :class="lineActive === 1 ? 'echart-item active' : 'echart-item'" @click="changeLine(1)">
              屈光曲线
            </div>
            <div :class="lineActive === 2 ? 'echart-item active' : 'echart-item'" @click="changeLine(2)">
              眼压曲线
            </div>
            <div :class="lineActive === 3 ? 'echart-item active' : 'echart-item'" @click="changeLine(3)">
              眼轴曲线
            </div>
            <div :class="lineActive === 4 ? 'echart-item active' : 'echart-item'" @click="changeLine(4)"
              v-if="openOrder">
              屈光预测
            </div>
          </div>
          <div v-if="lineActive === 0" class="echart-content">
            <div class="chart-tip">
              视力是指视网膜分辨影像的能力。正常视力值为≥5.0（1.0）。婴幼儿的视力是一个逐渐发育的过程，约6～7岁可达到1.0水平。
            </div>
            <div class="echart-box" id="chart"></div>
            <div class="echart-box" id="chart11" v-show="show11"></div>
            <div class="echart-bottom-tip" v-if="
                returnVersionMap != null &&
                returnVersionMap.showRightVersion != null &&
                returnVersionMap.showRightVersion != ''
              ">
              {{ returnVersionMap.showRightVersion }}
            </div>
            <div class="echart-bottom-tip" v-if="
                returnVersionMap != null &&
                returnVersionMap.showLeftVersion != null &&
                returnVersionMap.showLeftVersion != ''
              ">
              {{ returnVersionMap.showLeftVersion }}
            </div>
          </div>

          <div v-show="lineActive === 1" class="echart-content">
            <div class="chart-tip">
              屈光不正是指眼睛在调节放松的状态下，平行光线通过眼的屈光系统，不能在视网膜上形成清晰的物像，而是成像在视网膜前或后方。屈光不正包括近视、远视及散光。
            </div>
            <div class="echart-box" id="chart2"></div>
            <div class="echart-box" id="chart12" v-show="show11"></div>
            <div class="echart-bottom-tip" v-if="
                returnDiopterRecordMap != null &&
                returnDiopterRecordMap.showRightDiopterRecord != null &&
                returnDiopterRecordMap.showRightDiopterRecord != ''
              " :style="
                rightResult != null && rightResult != ''
                  ? 'margin-bottom: 0'
                  : ''
              ">
              {{ returnDiopterRecordMap.showRightDiopterRecord }}
            </div>

            <div class="echart-bottom-tip" v-if="rightResult != null && rightResult != ''">
              右眼近视进展：{{ rightResult }}
            </div>
            <div class="echart-bottom-tip" v-if="
                returnDiopterRecordMap != null &&
                returnDiopterRecordMap.showLeftDiopterRecord != null &&
                returnDiopterRecordMap.showLeftDiopterRecord != ''
              " :style="
                leftResult != null && leftResult != '' ? 'margin-bottom: 0' : ''
              ">
              {{ returnDiopterRecordMap.showLeftDiopterRecord }}
            </div>
            <div class="echart-bottom-tip" v-if="leftResult != null && leftResult != ''">
              左眼近视进展：{{ leftResult }}
            </div>
          </div>

          <div v-show="lineActive === 2" class="echart-content">
            <div class="chart-tip">
              眼压就是眼球内部的压力，正常眼压的范围为10mmHg～21mmHg，两眼压差一般不大于5mmHg，昼夜波动差应在5mmHg范围内。
            </div>
            <div class="echart-box" id="chart3"></div>
            <div class="echart-box" id="chart13" v-show="show11"></div>
          </div>

          <div v-show="lineActive === 3" class="echart-content">
            <div class="chart-tip">
              眼轴长度是指眼球从前到后的长度。眼轴长度在出生时为16mm，13～14岁可达到成人正常水平24mm。眼轴每增长1mm，近视度数将增加约300度。
            </div>
            <div class="echart-box" id="chart4"></div>
            <div class="echart-box" id="chart14" v-show="show11"></div>
            <div class="echart-bottom-tip" v-if="
                returnAxialLengthMap != null &&
                returnAxialLengthMap.showRightAxialLength != null &&
                returnAxialLengthMap.showRightAxialLength != ''
              ">
              {{ returnAxialLengthMap.showRightAxialLength }}
            </div>
            <div class="echart-bottom-tip" v-if="
                returnAxialLengthMap != null &&
                returnAxialLengthMap.showLeftAxialLength != null &&
                returnAxialLengthMap.showLeftAxialLength != ''
              ">
              {{ returnAxialLengthMap.showLeftAxialLength }}
            </div>

            <div class="jingshipinggu" v-if="jingshiPinggu != null && jingshiPinggu != ''">
              <div class="jingshipinggu-title">
                根据行为习惯<br />预计屈光度年增长
              </div>
              <div class="jingshipinggu-result">
                {{ jingshiPinggu }}
                <div style="font-size: 0.32rem">({{ jingshiDegree }}度)</div>
              </div>
            </div>
            <div class="echart-bottom-tip" v-if="resultFunctionInfo || selFunctionInfo">
              <div class="jsjz-title">近视进展观察</div>
              <div style="background: #eee; padding: 0.15rem; line-height: 1.6em">
                <div>
                  初步判断：<span style="color: #f00">{{
                    resultFunctionInfo
                    }}</span>
                </div>
                <div>{{ selFunctionInfo }}</div>
              </div>
            </div>
          </div>

          <div v-show="lineActive == 4" class="echart-content" style="font-size: 0.3rem;">
            <div style="display: flex;margin-bottom: 0.5rem;">
              <van-radio-group v-model="preListTxt" style="display: flex;align-items: center;justify-content: space-between;width: 100%;font-size: 0.26rem">
                <van-radio name="无干预" checked-color="#07c160" @click="onGoPreLine(0)">
                  无干预</van-radio>
                <van-radio name="角膜塑形镜" checked-color="#07c160" @click="onGoPreLine(1)">
                  角膜塑形镜</van-radio>
                <van-radio name="周边离焦" checked-color="#07c160" @click="onGoPreLine(2)">
                  周边离焦</van-radio>
                <van-radio name="多焦软镜" checked-color="#07c160" @click="onGoPreLine(3)">
                  多焦软镜</van-radio>
              </van-radio-group>
            </div>
            <div>屈光预测数值(右眼)</div>
            <div class="echart-box" id="chart5"></div>
            <div>屈光预测数值(左眼)</div>
            <div class="echart-box" id="chart6"></div>
            <van-popup v-model="showPreList" position="bottom">
              <van-picker :columns="preList" show-toolbar value-key="name" cancel-button-text="取消"
                confirm-button-text="确定" @cancel="showPreList = false" @confirm="onConfirmPreLine" />
            </van-popup>
          </div>
        </div>

        <div v-if="item.name == '干眼分析'" style="padding-bottom: 4rem; background: #fff">
          <div>
            <!-- <div class="chart-tip">眼压就是眼球内部的压力，正常眼压的范围为10mmHg～21mmHg，两眼压差一般不大于5mmHg，昼夜波动差应在5mmHg范围内。</div> -->
            <div class="echart-box" id="chartGanYan1"></div>
            <div class="echart-box" id="chartGanYan2"></div>
            <div class="echart-box" id="chartGanYan3"></div>
            <div class="echart-box" id="chartGanYan4"></div>
          </div>
        </div>

        <dicome-page v-if="index === 3" :dicome-list="dicomeList" :class="showWj ? 'show-wj' : 'no-wj'" />

        <div v-if="item.name == '订单记录'" style="padding-bottom: 4rem; background: #fff">
          <div class="orderlist">
            <div class="order-head">
              <div v-if="
                  orderHospitalId == 195 ||
                  orderHospitalId == 1044 ||
                  orderHospitalId == 122 ||
                  orderHospitalId == 121
                " class="total-info">
                <div style="width: 30%">会员等级: {{ memberLevel }}</div>
                <div style="width: 30%">储值余额: {{ storeValueBalance }}</div>
                <div style="width: 30%">积分余额: {{ pointBalance }}</div>
              </div>
              <div v-if="
                  orderHospitalId == 195 ||
                  orderHospitalId == 1044 ||
                  orderHospitalId == 122 ||
                  orderHospitalId == 121
                " class="total-info">
                <div style="width: 30%">套餐名称: {{ packageName }}</div>
                <div style="width: 30%">消费次数: {{ consumptionNumber }}</div>
                <div style="width: 30%">剩余次数: {{ residueNumber }}</div>
              </div>

              <div class="total-info">
                <div>累计消费金额:{{ sumPrice }}元</div>
                <br />
              </div>
            </div>

            <div v-for="(item, index) in orderList" style="
                text-align: left;
                margin-bottom: 10px;
                border-radius: 10px;
                border: 1.5px solid #dddddd;
              " :key="index" class="report-div-data">
              <div style="
                  border-bottom: 2px solid #e5e5e5;
                  padding-bottom: 5px;
                  padding-top: 5px;
                ">
                <span style="
                    padding-left: 10px;
                    padding-bottom: 5px;
                    border-left: 2px solid #f0a25c;
                    text-align: left;
                  ">日期:
                  {{
                  item.createDate
                  }}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span style="text-align: left; font-size: 15px; margin-left: 12px">金额: {{ item.sellTotal
                  }}元</span><br />
              </div>
              <div style="padding-bottom: 5px; padding-top: 5px">
                <span style="text-align: left; font-size: 15px; margin-left: 12px">产品: {{ item.goodsName
                  }}</span><br />
              </div>
              <div style="padding-bottom: 5px; padding-top: 5px">
                <span style="text-align: left; font-size: 15px; margin-left: 12px">门店: {{ item.shopName }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div v-if="isShowWj" class="url-mask">
      <div class="mask">
        <div class="mask-close" @click="isShowWj = false">
          <img src="../../assets/img/close.png" />
        </div>
        <div class="url-title">问卷列表</div>
        <div v-for="(item, index) in wjUrlList" :key="index" class="url-list">
          <div v-if="item.wjUrl == null || item.wjUrl == ''">
            {{ item.title }}
          </div>
          <a :href="item.wjUrl" v-if="item.wjUrl != null && item.wjUrl != ''">
            <div>
              {{ item.title }}
            </div>
          </a>
        </div>
        <div v-if="wjUrlList.length == 0" class="url-list">暂无问卷</div>
      </div>
    </div>
    <div v-show="isShowTip" class="priview-tip">点击屏幕关闭预览</div>
    <!-- div v-show="isShowUpdate" class="update-div">
      <van-button type="info" class="btn" @click="goUpdate()">修改</van-button>
      <van-button type="info" class="btn" @click="goDel()">删除</van-button>
    </div -->
    <div v-if="showEwm" class="maskbox">
      <div class="mask pb-30">
        <div class="maskclose" @click="showEwm = false">
          <img src="../../assets/img/close.png" />
        </div>
        <div class="codetip">{{ studentName }}</div>
        <div id="qrCode" class="ewmcode" ref="qrCodeDiv"></div>
        <div class="codetip">
          <div>检查时，请出示此二维码。</div>
          <div class="txt-left">
            离院后如需咨询医生，请关闭此页，点击公众号左下角“在线咨询”，按提示选择医生咨询
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="isShowConfirm">
      <div class="con_box">
        <div class="pop-btn">
          <h3>提示</h3>
          <p>确定删除该档案吗？</p>
          <span @click="goCancel()">取消</span>
          <span @click="deleteHea()">确定</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
import QRCode from "qrcodejs2";
import dicomePage from "../../components/dicomePage.vue";
import wx from "weixin-js-sdk";
import { setLineOption, formatList } from './js/detail'
import { formatAge,formatWeight,formatHeight,formatVal,formatGy,formatFixed2,formatDate,formatShili } from "./js/filters";

export default {
  name: "detail",
  components: { dicomePage },
  data() {
    return {
      archivesNo: "",
      show11: true,
      isShowUpdate: false,
      isShowConfirm: false,
      showEwm: false,
      showLoading: 1,
      customerUrl: "",
      model: {},
      dicomeList: [],
      orderList: [],
      sumPrice: 0,
      consumptionNumber: 0,
      memberLevel: "",
      packageName: "",
      pointBalance: 0,
      residueNumber: 0,
      storeValueBalance: 0,
      orderHospitalId: 0,
      list: "",
      showWj: false,
      lineActive: 0,
      recordList: { list: "" },
      tabList: [
        { name: "检查报告" },
        { name: "视光曲线" },
        { name: "体质辨识" },
        { name: "影像结果" },
      ],
	  diseaseData : [
	  		{ id: 1, name: '肝炎', key: 'otherHepatitis', hasDisease: false },
	  		{ id: 2, name: '肾炎', key: 'otherNephritis', hasDisease: false },
	  		{ id: 3, name: '心脏病', key: 'otherHeartDisease', hasDisease: false },
	  		{ id: 4, name: '高血压', key: 'otherHighBloodPressure', hasDisease: false },
	  		{ id: 5, name: '贫血', key: 'otherAnemia', hasDisease: false },
	  		{ id: 6, name: '糖尿病', key: 'otherDiabetes', hasDisease: false },
	  		{ id: 7, name: '过敏性疾病', key: 'otherAllergicAsthma', hasDisease: true },
	  		{ id: 8, name: '身体残疾', key: 'otherPhysicalIllness', hasDisease: false }
	  ],
      reportContent: "1",
      studentInfo: [],
      openOrder: 1,
      visionInfo: [],
      diopterInfo: [],
      otherInfo: [],
      codeUri: "",

      wjFlag: "",
      wjUrl: "",
      isShowWj: false,
      wjUrlList: [],

      ktwjUrlList: [],
      phyUrl: "",
      detailTitle: "",

      showArray: Array(50).fill(0),
      showTr: Array(50).fill(0),
	  showVisionInfo: true,
      csResult: "",
      womenStr: "",
      showSj: 0,
      medicalInfo: [],

      jingshiPinggu: "",
      jingshiDegree: "",
      counselUrl: "",

      leftMap: {},
      leftAgeList: {},
      leftValue: {},

      rightMap: {},
      rightAgeList: {},
      rightValue: {},

      returnVersionMap: {},
      rightAvgVersion: {},
      rightVisionList: {},
      leftAvgVersion: {},
      leftVisionList: {},

      returnDiopterRecordMap: {},
      leftAvgDiopterRecord: {},
      rightAvgDiopterRecord: {},
      leftSeList: {},
      rightSeList: {},

      gyMapList: {},
      rightGyList: {},
      leftGyList: {},
      rightGyList1: {},
      leftGyList1: {},

      leftPressureList: {},
      rightPressureList: {},

      returnAxialLengthMap: {},
      leftAxialLengthList: {},
      rightAxialLengthList: {},
      leftAvgAxialLength: {},
      rightAvgAxialLength: {},

      color: ["#5b9bd5", "#ff9933", "#cc9933", "#ff0000"],
      color1: ["#5b9bd5", "#ff9933", "#cccccc"],
      ageList: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],

      leftResult: "",
      rightResult: "",
      isShowTip: 0,
      showDiv: Array(50).fill(0),
      isChat: 0,
      visualFunctionArr: [
        "近视控制无效",
        "近视控制弱效",
        "近视控制中效",
        "近视控制强效",
      ],
      resultFuctionArr: [
        "近视控制无效，是指近视增长速率≤-0.75D/年，或眼轴增长速率≥0.27mm/年。",
        "近视控制弱效，是指近视增长速率-0.50D/年≥x>-0.75D/年，或眼轴增长速率 0.18mm/年≤y＜0.27mm/年。",
        "近视控制中效，是指近视增长速率-0.25D/年≥x>-0.50D/年，或眼轴增长速率 0.09mm/年≤y＜0.18mm/年。",
        "近视控制强效，是指近视增长速率>-0.25D/年，或眼轴增长速率＜0.09mm/年。",
      ],
      visualFunctionInfo: [],
      leftFunctionInfo: "",
      rightFunctionInfo: "",
      resultFunctionInfo: "",
      selFunctionInfo: "",
      accountId: "",
      qxData: [],
      ganYanMap: [],
      sid: "",
      shareLink: "",
      shareResult: "",
      shareName: "",
      shareConfig2: "",

      showReport: true,
      showAvgInfo: true,
      showFirstInfo: true,
      showSenseInfo: true,
      showMedicalInfo: true,
      showTeeth: true,
      showJz: true,
      showTj: true,
	  showJbHistory: true,
      showDipterInfo: true,
      showPress: true,
      showAllReport: true,
      showBallInfo: true,
      showBallAvg: true,
      showBallChapian: true,
      showBallAvg1: true,
      showBallZhujue: true,
      showVisualFunction: true,
      showSensitive: true,
      showRange: true,
      showFunctionPicture: true,
      preList: [
        { id: '0', name: "无干预" },
        { id: '1', name: "角膜塑形镜" },
        { id: '2', name: "周边离焦" },
        { id: '3', name: "多焦软镜" },
      ],
      showPreList: false,
      preListTxt: '无干预',
	  medicalInfoHasValue: false,
	  showNoInfoMsg: false,
	  showStudentInfo: false,
    };
  },
  mounted() {
    this.sid = this.$route.query.sid;
    this.onGetWenjuan();
    this.openId = localStorage.getItem("openId");
    if (this.$route.query.openId != null && this.$route.query.openId != "") {
      this.openId = this.$route.query.openId;
    }
    this.accountId = this.$route.query.accountId;
    setTimeout(() => {
      this.getTitle();
      this.getReport(this.sid);
      this.getJinshiPingu();
    }, 500);
  },
  methods: {
    changeLine(n) {
      this.lineActive = n;
      setTimeout(() => {
        if (n == 0) {
          let rightArr = this.rightVisionList.arr[1]
            ? this.rightVisionList.arr[1]
            : [];
          let leftArr = this.leftVisionList.arr[1]
            ? this.leftVisionList.arr[1]
            : [];
          if (rightArr.length > 0) {
            rightArr.forEach((item, index) => {
              rightArr[index] = item ? parseFloat(item).toFixed(1) : item;
            });
          }
          if (leftArr.length > 0) {
            leftArr.forEach((item, index) => {
              leftArr[index] = item ? parseFloat(item).toFixed(1) : item;
            });
          }
          this.drawLine(
            "chart",
            rightArr,
            leftArr,
            3,
            5.5,
            this.ageList,
            this.rightVisionList.arr[0],
            this.rightVisionList.arrStandard,
            "视力值",
            "",
            "",
            true
          );
          this.setChartData(0);
        }
        if (n == 1) {
          this.drawLine(
            "chart2",
            this.rightSeList.arr[1] ? this.rightSeList.arr[1] : [],
            this.leftSeList.arr[1] ? this.leftSeList.arr[1] : [],
            -8,
            5,
            this.ageList,
            this.rightSeList.arr[0],
            this.rightSeList.arrStandard,
            "等效球镜度(D)"
          );
          this.setChartData(1);
        }
        if (n == 2) {
          this.drawLine(
            "chart3",
            this.rightPressureList.arr[0] ? this.rightPressureList.arr[0] : [],
            this.leftPressureList.arr[0] ? this.leftPressureList.arr[0] : [],
            10,
            30,
            this.ageList,
            this.rightPressureList.arr[0],
            this.rightPressureList.arrStandard,
            "眼压(mmHg)"
          );
          this.setChartData(2);
        }
        if (n == 3) {
          this.drawLine(
            "chart4",
            this.rightAxialLengthList.arr[1]
              ? this.rightAxialLengthList.arr[1]
              : [],
            this.leftAxialLengthList.arr[1]
              ? this.leftAxialLengthList.arr[1]
              : [],
            15,
            30,
            this.ageList,
            this.rightAxialLengthList.arr[0],
            this.rightAxialLengthList.arrStandard,
            "轴长(mm)"
          );
          this.setChartData(3);
        }
        if (n == 4) {
          this.onGoPreLine(0)
        }
        if (n == 5) {
          this.drawLine(
            "chartGanYan1",
            this.rightGyList.arr[0] ? this.rightGyList.arr[0] : [],
            this.leftGyList.arr[0] ? this.leftGyList.arr[0] : [],
            1,
            20,
            this.ageList,
            [],
            this.rightGyList.arrStandard,
            "首次破裂时间"
          );
          this.drawLine(
            "chartGanYan3",
            this.rightGyList.arr[0] ? this.rightGyList.arr[0] : [],
            this.leftGyList.arr[0] ? this.leftGyList.arr[0] : [],
            1,
            20,
            this.rightGyList.arr[2],
            [],
            [],
            "首次破裂时间",
            "",
            "日期"
          );

          this.drawLine(
            "chartGanYan2",
            this.rightGyList.arr[1] ? this.rightGyList.arr[1] : [],
            this.leftGyList.arr[1] ? this.leftGyList.arr[1] : [],
            1,
            20,
            this.ageList,
            [],
            this.rightGyList.arrStandard,
            "平均破裂时间"
          );

          this.drawLine(
            "chartGanYan4",
            this.rightGyList.arr[1] ? this.rightGyList.arr[1] : [],
            this.leftGyList.arr[1] ? this.leftGyList.arr[1] : [],
            1,
            20,
            this.rightGyList.arr[2],
            [],
            [],
            "平均破裂时间",
            "",
            "日期"
          );
        }
      }, 200);
    },
    drawLine(id,rightData,leftData,sourceMin,sourceMax,xData,avg,arrStandard,yName,otherName,xName,formatY) {
      const option = setLineOption(id, rightData, leftData, sourceMin, sourceMax, xData, avg, arrStandard, yName, otherName, xName, formatY);
      let myChart = this.$echarts.init(document.getElementById(id));
      myChart.setOption(option);
    },
    setChartData(index) {
      let data = this.qxData;
      if (data != null && data != "") {
        if (
          index == 0 &&
          data[0] != null &&
          data[0] != "" &&
          data[0].eyeChartNames != null
        ) {
          data[0] = this.sortData(
            data[0],
            "eyeChartNames",
            "leftEyeChartValues",
            "rightEyeChartValues"
          );
          if (data[0] != null && data[0] != "") {
            let rightData1 = [
              ...data[0]["rightEyeChartValues"],
              ...data[0]["rightEyeChartValues2"],
              ...data[0]["rightEyeChartValues3"],
            ];
            let leftData1 = [
              ...data[0]["leftEyeChartValues"],
              ...data[0]["leftEyeChartValues2"],
              ...data[0]["leftEyeChartValues3"],
            ];
            if (rightData1.length > 0) {
              rightData1.forEach((item, index) => {
                rightData1[index] = item ? parseFloat(item).toFixed(1) : item;
              });
            }
            if (leftData1.length > 0) {
              leftData1.forEach((item, index) => {
                leftData1[index] = item ? parseFloat(item).toFixed(1) : item;
              });
            }
            this.drawLine(
              "chart11",
              rightData1,
              leftData1,
              3.0,
              5.5,
              data[0].eyeChartNames,
              [],
              data[0].markLineData,
              "视力值",
              "",
              "日期",
              true
            );
          }
        }
        if (
          index == 1 &&
          data[1] != null &&
          data[1] != "" &&
          data[1].eyeChartNames != null
        ) {
          data[1] = this.sortData(
            data[1],
            "eyeChartNames",
            "leftEyeChartValues",
            "rightEyeChartValues"
          );
          if (data[1] != null && data[1] != "") {
            let leftData2 = [
              ...data[1]["leftEyeChartValues"],
              ...data[1]["leftEyeChartValues2"],
              ...data[1]["leftEyeChartValues3"],
            ];
            let rightData2 = [
              ...data[1]["rightEyeChartValues"],
              ...data[1]["rightEyeChartValues2"],
              ...data[1]["rightEyeChartValues3"],
            ];

            this.drawLine(
              "chart12",
              rightData2,
              leftData2,
              -8,
              5,
              data[1].eyeChartNames,
              [],
              data[1].markLineData,
              "等效球镜度(D)",
              "",
              "日期"
            );
          }
        }

        if (
          index == 2 &&
          data[2] != null &&
          data[2] != "" &&
          data[2].eyeChartNames != null
        ) {
          data[2] = this.sortData(
            data[2],
            "eyeChartNames",
            "leftEyeChartValues",
            "rightEyeChartValues"
          );
          if (data[2] != null && data[2] != "") {
            let leftData3 = [
              ...data[2]["leftEyeChartValues"],
              ...data[2]["leftEyeChartValues2"],
              ...data[2]["leftEyeChartValues3"],
            ];
            let rightData3 = [
              ...data[2]["rightEyeChartValues"],
              ...data[2]["rightEyeChartValues2"],
              ...data[2]["rightEyeChartValues3"],
            ];
            this.drawLine(
              "chart13",
              rightData3,
              leftData3,
              10,
              30,
              data[2].eyeChartNames,
              [],
              data[2].markLineData,
              "眼压(mmHg)",
              "",
              "日期"
            );
          }
        }
        if (
          index == 3 &&
          data[3] != null &&
          data[3] != "" &&
          data[3].eyeChartNames != null
        ) {
          data[3] = this.sortData(
            data[3],
            "eyeChartNames",
            "leftEyeChartValues",
            "rightEyeChartValues"
          );
          if (data[3] != null && data[3] != "") {
            let leftData4 = [
              ...data[3]["leftEyeChartValues"],
              ...data[3]["leftEyeChartValues2"],
              ...data[3]["leftEyeChartValues3"],
            ];
            let rightData4 = [
              ...data[3]["rightEyeChartValues"],
              ...data[3]["rightEyeChartValues2"],
              ...data[3]["rightEyeChartValues3"],
            ];
            this.drawLine(
              "chart14",
              rightData4,
              leftData4,
              15,
              30,
              data[3].eyeChartNames,
              [],
              data[3].markLineData,
              "轴长(mm)",
              "",
              "日期"
            );
          }
        }
      }
    },
    setMinOrMax(source, dataArr, type) {
      let value = source;
      if (dataArr && dataArr != [] && dataArr.length > 0) {
        dataArr.forEach((item) => {
          if (type == "min") {
            if (typeof item != "object" && item && item < value) value = item;
          }
          if (type == "max") {
            if (item && item > value) value = item;
          }
        });
      }
      return value;
    },
    async onGetWenjuan() {
      this.ktwjUrlList = [];
      let result = await this.$http.get(this.$url.getWenJuanList, {
        studentId: this.$route.query.sid,
      });
      let list = result.data.list;
      this.ktwjUrlList = list;
    },
    getArrayIndex(arr, obj) {
      var i = arr.length;
      while (i--) {
        if (arr[i] === obj) {
          return i;
        }
      }
      return -1;
    },
    /**
     * 获得记录
     */
    async getReport(sid) {
      let activityId = this.$route.query.activityId;
      let auth = this.$createAuth(this.$md5);
      activityId == undefined || activityId == "undefined" ? "" : activityId;
      let result = await this.$http.get(this.$url.checkDetail, {
        studentId: sid,
        openId: this.openId,
        activityId: activityId,
        screenType: this.$route.query.screenType,
        auth: auth.code,
        time: auth.time,
      });
      this.openOrder = result.data.openOrder;
      if (this.openOrder == 1) {
        this.tabList.push({ name: "订单记录" });
      }
      let _this = this;
      if (result.message === "Error: Miss auth parameter.") {
        setTimeout(function () {
          _this.getReport(sid);
        }, 500);
      } else {
        this.reportContent = result.data.visionInfo.reportContent
          ? result.data.visionInfo.reportContent
          : "1";
        if (this.reportContent) {
          if (
            this.reportContent.indexOf("1") > -1 &&
            this.reportContent.indexOf("2") < 0
          ) {
            //不显示干眼分析
          } else if (
            this.reportContent.indexOf("1") < 0 &&
            this.reportContent.indexOf("2") > -1
          ) {
            // this.tabList[1].name = '干眼分析'
            //不显示视光曲线
            this.tabList = [
              { name: "检查报告" },
              { name: "干眼分析" },
              { name: "体质辨识" },
              { name: "影像结果" },
            ];
          } else if (
            this.reportContent.indexOf("1") > -1 &&
            this.reportContent.indexOf("2") > -1
          ) {
            //2个都显示
            this.tabList = [
              { name: "检查报告" },
              { name: "视光曲线" },
              { name: "体质辨识" },
              { name: "影像结果" },
              { name: "干眼分析" },
            ];
          }
        } else {
          this.reportContent = "1";
        }
        if (result.data && result.data.jinshiResult) {
          this.leftFunctionInfo = result.data.jinshiResult.leftResult;
          this.rightFunctionInfo = result.data.jinshiResult.rightResult;
        }
        this.archivesNo = result.data.archivesNo;
        let tempLeft = this.getArrayIndex(
          this.visualFunctionArr,
          this.leftFunctionInfo
        );
        let tempRight = this.getArrayIndex(
          this.visualFunctionArr,
          this.rightFunctionInfo
        );
        if (tempLeft <= tempRight) {
          this.resultFunctionInfo = this.leftFunctionInfo;
          this.selFunctionInfo = this.resultFuctionArr[tempLeft];
        } else {
          this.resultFunctionInfo = this.rightFunctionInfo;
          this.selFunctionInfo = this.resultFuctionArr[tempRight];
        }

        this.isChat = result.data?.isChat;
        this.counselUrl = result.data.counselUrl;
		this.reportVersion = result.data.reportVersion === 1 ? false : true;
        this.studentInfo = result.data.studentInfo;
        let name = this.desensitizationName(this.studentInfo.studentName);
        let resAccount = await this.$http.get(this.$url.getAccount, {
          openId: this.openId,
        });
        this.goShare(resAccount.data.account, name);
        this.detailTitle = result.data.title;
        this.phyUrl = this.studentInfo.phyUrl;
        this.visionInfo = result.data.visionInfo;
		
		this.showVisionInfo = this.visionInfo != null &&
		((this.visionInfo.rightNakedeyeVision != null && this.visionInfo.rightNakedeyeVision != '') || 
		 (this.visionInfo.leftNakedeyeVision != null && this.visionInfo.leftNakedeyeVision != '') ||
		 (this.visionInfo.rightGlassesVision != null && this.visionInfo.rightGlassesVision != '') || 
		 (this.visionInfo.leftGlassesVision != null && this.visionInfo.leftGlassesVision != '') ||
		 (this.visionInfo.glassesType != null && this.visionInfo.glassesType != '') )
		 
		
		if(this.detailTitle == '眼科门诊检查记录'){
			this.showStudentInfo = (this.studentInfo &&
                (this.studentInfo.sg ||
                  this.studentInfo.tz ||
                  this.studentInfo.bloodSugar ||
                  this.studentInfo.otherShrinkage ||
                  this.studentInfo.otherDiastolic ||
                  this.studentInfo.bmi))
		}
		

        this.otherInfo = result.data.otherInfo;
        this.ganYanMap = result.data.ganYanMap;
        this.diopterInfo = result.data.diopterInfo;
        this.wjFlag = this.studentInfo.wjFlag;
        this.csResult = result.data.result;
        if (this.csResult != null && this.csResult.womenFlag) {
          this.womenStr =
            "本次屈光筛查为非睫状肌麻痹下验光进行筛查，结果不具有诊断意义。";
        }
        this.model = result.data.ganYanReportMap;
        this.medicalInfo = result.data.medicalInfo || {};
		this.diseaseData.forEach(disease => {
		        if (this.medicalInfo && this.medicalInfo.hasOwnProperty(disease.key)) {
		            disease.hasDisease = this.medicalInfo[disease.key] == 1;
		        }
		});
        this.customerUrl = result.data.customerUrl;
        this.visualFunctionInfo = result.data.visualFunctionInfo;
        this.setShowDiv(this.diopterInfo, "diopterInfo");
        this.setShowDiv(this.otherInfo, "otherInfo");
        this.setShowDiv(this.medicalInfo, "medicalInfo");
        this.setShowDiv(this.visualFunctionInfo, "visualFunctionInfo");
        if (this.visualFunctionInfo != null) {
          this.leftResult = this.visualFunctionInfo.leftResult;
          this.rightResult = this.visualFunctionInfo.rightResult;
          this.leftFunctionInfo = this.visualFunctionInfo.leftResult;
          this.rightFunctionInfo = this.visualFunctionInfo.rightResult;
        }
        this.vsualSenseInfo = result.data.vsualSenseInfo;

        if (
          this.csResult != null &&
          this.csResult.womenFlag &&
          this.vsualSenseInfo != null
        ) {
          this.showSj = 1;
        }
        if (this.wjFlag == 0) {
          this.showWj = false;
        } else {
          this.showWj = true;
        }
        if (this.ktwjUrlList && this.ktwjUrlList.length > 0) {
          this.showWj = true;
        }
        this.wjUrl = this.studentInfo.wjUrl;
        let list = this.otherInfo.otherRightPicture;
        if (list && list.length > 0) this.list = list.split(",");
        // if (this.wjUrl == null || this.wjUrl == "") this.getWjUrlList(sid);
        if (this.otherInfo != null) {
          this.setShowArray(this.otherInfo, ["rightLamp", "leftLamp"], 1);
          this.setShowArray(this.otherInfo, ["dryEye", "dryEye"], 2);
          this.setShowArray(
            this.otherInfo,
            ["rightPentacam", "leftPentacam"],
            3
          );
          this.setShowArray(
            this.otherInfo,
            ["rightBiologyForce", "leftBiologyForce"],
            4
          );
          this.setShowArray(
            this.otherInfo,
            ["rightBiometricsPicture", "leftBiometricsPicture"],
            5
          );
          this.setShowArray(
            this.otherInfo,
            [
              "rightAxialLength",
              "leftAxialLength",
              "rightEyeCurvatureR1",
              "rightEyeCurvatureR2",
              "rightAxialView1",
              "rightAxialView2",
              "leftEyeCurvatureR1",
              "leftEyeCurvatureR2",
              "leftAxialView1",
              "leftAxialView2",
              "rightAcd",
              "rightWtw",
              "rightCentreCorneaPly",
              "leftAcd",
              "leftWtw",
              "leftCentreCorneaPly",
            ],
            6
          );
          this.setShowArray(this.otherInfo, ["rightTopographyPicture"], 18);
          this.setShowArray(this.otherInfo, ["rightXBJ", "leftXBJ"], 7);
          this.setShowArray(
            this.otherInfo,
            ["rightPerimeter", "leftPerimeter"],
            8
          );
          this.setShowArray(
            this.otherInfo,
            ["rightOCT", "leftOCT", "rightMlmThickness", "leftMlmThickness"],
            9
          );
          this.setShowArray(
            this.otherInfo,
            ["rightFundusCamera", "leftFundusCamera"],
            10
          );
          this.setShowArray(
            this.otherInfo,
            ["glassesRecipe", "glassesRecipe"],
            12
          );
          this.setShowArray(this.otherInfo, ["rightAbchao", "leftAbchao"], 13);
          this.setShowArray(
            this.otherInfo,
            ["rightMlmThickness", "leftMlmThickness"],
            14
          );
          this.setShowArray(
            this.otherInfo,
            ["rightEyePressure", "leftEyePressure"],
            15
          );
          this.setShowArray(
            this.otherInfo,
            ["rightBiometricsPicture", "leftBiometricsPicture"],
            16
          );
          this.setShowArray(
            this.otherInfo,
            ["rightBiometricsPicture", "leftBiometricsPicture"],
            17
          );
        }
        if (this.list != null && this.list != "" && this.list.length > 0) {
          this.showArray[11] = 1;
          this.showTr[11] = 1;
        }
        if (result.data.isUpdateDel == 1) {
          this.isShowUpdate = true;
        }
		
		this.validateMedicalInfo();
      }
	  
	  if(this.detailTitle == '筛查结果报告'){
		  this.showNoInfoMsg = !this.showSj && !this.showDiv[0] && !this.showDiv[1] &&  !this.showDiv[14] && !this.showArray[14] 
					  && !this.showArray[18] && !this.showArray[9] && !this.showArray[8] && 
					 !this.showArray[7] && !this.showArray[6] && !this.showArray[5] && !this.showArray[4] 
					 && !this.showArray[3] && !this.showArray[2] && 
					 !this.showArray[1] && !this.medicalInfoHasValue && !this.showVisionInfo;
	  }else if(this.detailTitle == '学生重点常见病监测表'){
		  this.showNoInfoMsg =  !this.showDiv[3] && !this.showDiv[5] && !this.showDiv[14] && !this.showArray[18] &&
		  			 !this.showArray[13] && !this.showArray[12] && !this.showArray[11] && !this.showArray[10] 
		  			 && !this.showArray[9] && !this.showArray[8] && 
		  			 !this.showArray[7] && !this.showArray[6] && !this.showArray[5] && !this.showArray[4] 
		  			 && !this.showArray[3] && !this.showArray[2] && 
		  			 !this.showArray[1] && !this.medicalInfoHasValue && !this.showVisionInfo;
	  }else if(this.detailTitle == '眼科门诊检查记录'){
		  this.showNoInfoMsg =  !this.showDiv[6] && !this.showDiv[7] && !this.showDiv[8] &&
				   !this.showDiv[9] && !this.showDiv[10] && !this.showDiv[12] && 
				   !this.showDiv[13] && !this.showDiv[14] && !this.showDiv[15] && !this.showDiv[16] && !this.showDiv[17] &&
				   !this.showArray[18] && !this.showArray[17] && !this.showArray[16] && !this.showArray[15] &&
					 !this.showArray[13] && !this.showArray[12] && !this.showArray[11] && !this.showArray[10] 
					 && !this.showArray[9] && !this.showArray[8] && 
					 !this.showArray[7] && !this.showArray[6] && !this.showArray[5] && !this.showArray[4] 
					 && !this.showArray[3] && !this.showArray[2] && 
					 !this.showArray[1] && !this.medicalInfoHasValue && !this.showVisionInfo && !this.showStudentInfo;
					 
	  }
	  
      this.showLoading = 0;
    },
    onConfirmPreLine(value) {
      this.showPreList = false;
      this.preListTxt = value.name;
      this.onGoPreLine(value.id)
    },
    onGoPreLine(n) {
      this.drawLine(
        "chart5",
        [this.rightValue[n]],
        [],
        -15,
        2,
        this.rightAgeList,
        [],
        [],
        "",
        [this.preList[n].name]
      );

      this.drawLine(
        "chart6",
        [this.leftValue[n]],
        [],
        -15,
        2,
        this.leftAgeList,
        [],
        [],
        "",
        [this.preList[n].name]
      );
     },
    async getLineByDate(sid) {
      let result = await this.$http.post(this.$url.getLineByDateData, {
        hospitalId: this.$route.query.hospitalId,
        archivesNo: sid,
        studentName: this.studentInfo.studentName,
      });
      if (result) {
        this.qxData = result;
      }
    },
    setShowArray(obj, arr, n) {
      if (n == 5) {
        if (this.reportContent && this.reportContent.indexOf(2) >= 0) {
          this.showArray[5] = 0;
          this.showTr[5] = 0;
          return;
        }
      } else if (n == 16) {
        if (this.reportContent) {
          if (
            this.reportContent.indexOf("1") > -1 &&
            this.reportContent.indexOf("2") < 0
          ) {
            //不显示干眼分析
            this.showArray[16] = 0;
            this.showTr[16] = 0;
          } else if (
            this.reportContent.indexOf("1") < 0 &&
            this.reportContent.indexOf("2") > -1
          ) {
            //不显示视光曲线
            this.showArray[16] = 1;
            this.showTr[16] = 1;
          } else if (
            this.reportContent.indexOf("1") > -1 &&
            this.reportContent.indexOf("2") > -1
          ) {
            //2个都显示
            this.showArray[16] = 1;
            this.showTr[16] = 1;
          }
        } else {
          this.showArray[16] = 0;
          this.showTr[16] = 0;
        }
        return;
      }
      arr.forEach((item) => {
        if (n == 17) {
          console.log(obj[item]);
        }
        if (obj[item] != null && obj[item] != "") {
          this.showArray[n] = 1;
          this.showTr[n] = 1;
        }
      });

      if (n == 6) {
        let arr1 = [
          "rightAxialLength",
          "leftAxialLength",
          "rightEyeCurvatureR1",
          "rightEyeCurvatureR2",
          "rightAxialView1",
          "rightAxialView2",
          "leftEyeCurvatureR1",
          "leftEyeCurvatureR2",
          "leftAxialView1",
          "leftAxialView2",
          "rightAcd",
          "rightWtw",
          "rightCentreCorneaPly",
          "leftAcd",
          "leftWtw",
          "leftCentreCorneaPly",
        ];
      }
    },

    setShowDiv(obj, type) {
      if (type == "diopterInfo") {
        let arr1 = [
          "avg_right_ball",
          "avg_right_sy",
          "avg_right_axial",
          "avg_left_ball",
          "avg_left_syl",
          "avg_left_axial",
          "pupilDistance",
        ];
        let arr2 = [
          "first_right_ball",
          "first_right_syl",
          "first_right_axial",
          "second_right_ball",
          "second_right_syl",
          "second_right_axial",
          "third_right_ball",
          "third_right_syl",
          "third_right_axial",
          "avg_right_ball",
          "avg_right_syl",
          "avg_right_axial",
          "right_se",
          "first_left_ball",
          "first_left_syl",
          "first_left_axial",
          "second_left_ball",
          "second_left_syl",
          "second_left_axial",
          "third_left_ball",
          "third_left_syl",
          "third_left_axial",
          "avg_left_ball",
          "avg_left_syl",
          "avg_left_axial",
          "left_se",
          "pupilDistance",
        ];
        let arr3 = [
          "rightBallZhujue",
          "rightSylZhujue",
          "rightAxialZhujue",
          "leftBallZhujue",
          "leftSylZhujue",
          "leftAxialZhujue",
          "xrygPupilDistance",
        ];
        let arr4 = [
          "rightBallAvgAfter",
          "rightSylAvgAfter",
          "rightAxialAvgAfter",
          "leftBallAvgAfter",
          "dlygsthPicture",
          "leftSylAvgAfter",
          "leftAxialAvgAfter",
          "pupilDistanceAfter",
        ];
        let arr5 = [
          "avg_right_ball",
          "avg_right_syl",
          "avg_right_axial",
          "avg_left_ball",
          "avg_left_syl",
          "avg_left_axial",
          "pupilDistance",
          "dlygPicture",
        ];
        let arr6 = [
          "rightBallChaPian",
          "rightSylChaPian",
          "rightAxialChaPian",
          "rightCorrectChaPian",
          "xrygsthPicture",
          "xrygsthPupilDistance",
          "leftBallChaPian",
          "leftSylChaPian",
          "leftAxialChaPian",
          "leftCorrectChaPian",
        ];
        let arr7 = [
          "rightBallZhujue_1",
          "rightSylZhujue_1",
          "rightAxialZhujue_1",
          "leftBallZhujue_1",
          "leftSylZhujue_1",
          "leftAxialZhujue_1",
          "xrygfyPupilDistance",
        ];
        let arr8 = [
          "rightBallAvgAfter1",
          "rightSylAvgAfter1",
          "rightAxialAvgAfter1",
          "leftBallAvgAfter1",
          "dlygfyPicture",
          "pupilDistanceAfter1",
          "leftSylAvgAfter1",
          "leftAxialAvgAfter1",
        ];
        for (let loop = 0; loop < arr1.length; loop++) {
          this.showDiv[0] =
            this.showDiv[0] ||
            (obj[arr1[loop]] != null && obj[arr1[loop]] != "");
          this.showDiv[3] =
            this.showDiv[3] ||
            (obj[arr1[loop]] != null && obj[arr1[loop]] != "");
        }
        for (let loop = 0; loop < arr2.length; loop++) {
          this.showDiv[1] =
            this.showDiv[1] ||
            (obj[arr2[loop]] != null && obj[arr2[loop]] != "");
          this.showDiv[5] =
            this.showDiv[5] ||
            (obj[arr2[loop]] != null && obj[arr2[loop]] != "");
        }
        for (let loop = 0; loop < arr3.length; loop++) {
          this.showDiv[6] =
            this.showDiv[6] ||
            (obj[arr3[loop]] != null && obj[arr3[loop]] != "");
        }
        for (let loop = 0; loop < arr4.length; loop++) {
          this.showDiv[7] =
            this.showDiv[7] ||
            (obj[arr4[loop]] != null && obj[arr4[loop]] != "");
        }
        for (let loop = 0; loop < arr5.length; loop++) {
          this.showDiv[8] =
            this.showDiv[8] ||
            (obj[arr5[loop]] != null && obj[arr5[loop]] != "");
        }
        for (let loop = 0; loop < arr6.length; loop++) {
          this.showDiv[9] =
            this.showDiv[9] ||
            (obj[arr6[loop]] != null && obj[arr6[loop]] != "");
        }
        for (let loop = 0; loop < arr7.length; loop++) {
          this.showDiv[10] =
            this.showDiv[10] ||
            (obj[arr7[loop]] != null && obj[arr7[loop]] != "");
        }
        for (let loop = 0; loop < arr8.length; loop++) {
          this.showDiv[13] =
            this.showDiv[13] ||
            (obj[arr8[loop]] != null && obj[arr8[loop]] != "");
        }
        for (let loop = 0; loop < arr8.length; loop++) {
          this.showDiv[13] =
            this.showDiv[13] ||
            (obj[arr8[loop]] != null && obj[arr8[loop]] != "");
        }
      }
      if (type == "otherInfo") {
        let arr1 = [
          "rightEyePressure",
          "leftEyePressure",
          "rightAxialLength",
          "leftAxialLength",
          "rightEyeCurvatureR1",
          "rightEyeCurvatureR2",
          "rightAxialView1",
          "rightAxialView2",
          "leftEyeCurvatureR1",
          "leftEyeCurvatureR2",
          "leftAxialView1",
          "leftAxialView2",
          "rightAcd",
          "rightWtw",
          "rightCentreCorneaPly",
          "rightBut",
          "leftAcd",
          "leftWtw",
          "leftCentreCorneaPly",
          "leftBut",
        ];
        let arr14 = ["rightEyePressure", "leftEyePressure"];
        for (let loop = 0; loop < arr1.length; loop++) {
          this.showDiv[2] =
            this.showDiv[2] ||
            (obj[arr1[loop]] != null && obj[arr1[loop]] != "");
          this.showDiv[11] =
            this.showDiv[11] ||
            (obj[arr1[loop]] != null && obj[arr1[loop]] != "");
        }

        for (let loop = 0; loop < arr14.length; loop++) {
          this.showDiv[14] =
            this.showDiv[14] ||
            (obj[arr14[loop]] != null && obj[arr14[loop]] != "");
        }
      }

      if (type == "medicalInfo") {
        if (obj != null) {
          let arr1 = [
            "babyTeethBu",
            "babyTeethQu",
            "babyTeethShi",
            "permanentTeethBu",
            "permanentTeethQu",
            "permanentTeethShi",
            "sg",
            "show1",
            "show2",
            "show3",
            "show4",
            "show5",
            "show6",
            "show7",
            "show8",
            "show9",
            "show10",
            "show11",
            "show12",
            "show13",
            "show14",
            "show15",
            "show16",
            "tz",
            "xy",
          ];
          for (let loop = 0; loop < arr1.length; loop++) {
            this.showDiv[4] =
              this.showDiv[4] ||
              (obj[arr1[loop]] != null && obj[arr1[loop]] != "");
          }
        }
      }
      if (type == "visualFunctionInfo") {
        let arr1 = [
          "dominant",
          "accNear",
          "conNear",
          "simult",
          "fusion",
          "stereopsis",
          "farDeviation",
          "nearDeviation",
          "aca",
          "minusRelative",
          "plusRelative",
          "accReaction",
          "farImagePlus",
          "farImageMinus",
          "nearImagePlus",
          "nearImageMinus",
          "stringBuilder",
        ];
        if (obj != null) {
          for (let loop = 0; loop < arr1.length; loop++) {
            this.showDiv[12] =
              this.showDiv[12] ||
              (obj[arr1[loop]] != null && obj[arr1[loop]] != "");
          }
        }

        let arr2 = ["eyesSensitive", "rightSensitive", "leftSensitive"];
        if (obj != null) {
          for (let loop = 0; loop < arr1.length; loop++) {
            this.showDiv[15] =
              this.showDiv[15] ||
              (obj[arr2[loop]] != null && obj[arr2[loop]] != "");
          }
        }

        let arr3 = ["eyesRange", "rightRange", "leftRange"];
        if (obj != null) {
          for (let loop = 0; loop < arr1.length; loop++) {
            this.showDiv[16] =
              this.showDiv[16] ||
              (obj[arr3[loop]] != null && obj[arr3[loop]] != "");
          }
        }
        let arr4 = ["visualFunctionPicture"];
        if (obj != null) {
          for (let loop = 0; loop < arr1.length; loop++) {
            this.showDiv[17] =
              this.showDiv[17] ||
              (obj[arr4[loop]] != null && obj[arr4[loop]] != "");
          }
        }
      }
    },
    /**
     * 显示详情表格数据
     */
    showTable(n, n1) {
      let val = 1 - this.showTr[n];
      this.$set(this.showTr, n, val);
      if (n1) {
        this.$set(this.showTr, n1, 1 - this.showTr[n1]);
      }
    },
    /**
     * 获得问卷地址列表
     */
    async getWjUrlList(sid) {
      let auth = this.$createAuth(this.$md5);
      if (this.$route.query.activityId != "") {
        let result = await this.$http.get(this.$url.questionList, {
          studentId: sid,
          activityId: this.$route.query.activityId,
          auth: auth.code,
          time: auth.time,
        });

        this.wjUrlList = result.data.list;
      }
    },
    /**
     * 跳问卷页面
     */
    async onGoWj() {
      await this.getWjUrlList(this.sid);
      if (this.wjUrl != "") {
        location.href = this.wjUrl;
      } else {
        this.wjUrlList = [...this.wjUrlList, ...this.ktwjUrlList];
        if (this.wjUrlList.length == 1) {
          let item = this.wjUrlList[0];
          location.href = item.wjUrl;
        } else {
          this.isShowWj = true;
        }
      }
    },
    /**
     * 图片预览
     */
    goPriview(src) {
      let listImg = [];
      if (src.indexOf(".pdf") >= 0) {
        window.open(src);
      } else {
        listImg.push(src);
        this.isShowTip = 1;
        let _this = this;
        ImagePreview({
          images: listImg,
          startPosition: 0,
          showIndex: false,
          onClose() {
            _this.isShowTip = 0;
          },
        });
      }
    },
    /**
     * 弹出二维码
     * @param item
     */
    goQr() {
      let _this = this;
      this.showEwm = true;
      let sid = this.studentInfo.uid;
      this.studentName = this.studentInfo.studentName;
      let url = this.studentInfo.codeUrl;
      setTimeout(function () {
        new QRCode(_this.$refs.qrCodeDiv, {
          text: url,
          width: 135,
          height: 135,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      }, 500);
    },

    /**
     * 图片加载失败处理
     */
    defImg() {
      let img = event.srcElement;
      img.style = "display:none";
      // img.src = require('../assets/img/none.png');
      // img.onerror = null; //防止闪图
    },
    /**
     * 获得近视评估
     */
    async getJinshiPingu() {
      let auth = this.$createAuth(this.$md5);
      let hospitalId = this.$route.query.hospitalId;
      if (
        hospitalId == null ||
        typeof hospitalId == undefined ||
        isNaN(hospitalId)
      )
        hospitalId = "";
      if (hospitalId != null && hospitalId != "") {
        let result = await this.$http.get(this.$url.jinshiPingu, {
          studentId: this.$route.query.tuid,
          hospitalId: hospitalId,
          auth: auth.code,
          time: auth.time,
        });
        let temp = result.data;
        if (temp != null && temp != "") {
          this.jingshiPinggu = temp.substring(0, temp.indexOf("("));
          let degree = temp.substring(temp.indexOf("(") + 1, temp.indexOf(")"));
          this.jingshiDegree =
            degree.indexOf("-") >= 0 ? degree.replace("-", "") : degree;
        }
      }
    },

    /**
     * 获得页面标题
     */
    async getTitle() {
      let openTitle = [];
      let openTitleStr = localStorage.getItem("openTitle");
      let title = "";
      if (openTitleStr && openTitleStr != "null") {
        openTitle = JSON.parse(openTitleStr);
        openTitle.forEach((obj, index) => {
          // 在这里执行其他需要对每个对象执行的操作
          if (this.openId === obj.openId) {
            title = obj.title;
          }
        });

        if (title) {
          document.title = title;
        } else {
          let auth = this.$createAuth(this.$md5);
          let result = await this.$http.get(this.$url.getTitle, {
            openId: this.openId,
            auth: auth.code,
            time: auth.time,
          });
          if (result.message === "Error: Miss auth parameter.") {
            this.getTitle();
          } else {
            title = result.data.title;
          }
          let objResult = { openId: this.openId, title: title };
          openTitle.push(objResult);
          localStorage.setItem("openTitle", JSON.stringify(openTitle));
        }
      } else {
        let auth = this.$createAuth(this.$md5);
        let result = await this.$http.get(this.$url.getTitle, {
          openId: this.openId,
          auth: auth.code,
          time: auth.time,
        });
        if (result.message === "Error: Miss auth parameter.") {
          this.getTitle();
        } else {
          title = result.data.title;
        }
        let objResult = { openId: this.openId, title: title };
        openTitle = [];
        openTitle.push(objResult);
        localStorage.setItem("openTitle", JSON.stringify(openTitle));
      }
      document.title = title;
    },

    /**
     * 跳互联网医院
     */
    onGoHospital() {
      location.href = "https://i.yjkok.com/hospital-vue/#/robot?openId=" + this.$route.query.openId + '&hospitalId=' + this.$route.query.hospitalId;
    },

    /**
     * 切换Tab页面
     */
    async changeTab(index, name) {
      console.log("name=" + name);
      if (this.wjFlag == 0) {
        this.showWj = false;
      } else {
        this.showWj = true;
      }
      if (this.ktwjUrlList && this.ktwjUrlList.length > 0) {
        this.showWj = true;
      }

      // if (index == 1 || index == 4) {
      //   this.showWj = false;
      //   await this.getLineByDate(this.archivesNo);
      //   if (name == '干眼分析'){
      //     await this.getLine(this.sid, 5);
      //   }else {
      //     await this.getLine(this.sid, index);
      //     this.changeLine(0);
      //   }
      // }
      if (name == "干眼分析" || name === "视光曲线") {
        this.showWj = false;
        await this.getLineByDate(this.archivesNo);
        await this.getLine(this.sid);
        if (name === "视光曲线") {
          this.changeLine(0);
        } else {
          this.changeLine(5);
        }
      }
      if (name == "订单记录") {
        this.showWj = false;
        this.studentIdByList();
      }

      if (index == 2) {
        if (this.phyUrl) location.href = this.phyUrl;
      }
      if (index == 3) {
        this.getDicomList();
      }
    },
    async getDicomList() {
      let result = await this.$http.get(this.$url.getDicomCheckList, {
        studentId: this.sid,
      });
      this.dicomeList = result.data?.chekList;
    },
    async studentIdByList() {
      this.sumPrice = 0;
      this.consumptionNumber = 0;
      this.memberLevel = "";
      this.packageName = "";
      this.pointBalance = 0;
      this.residueNumber = 0;
      this.storeValueBalance = 0;
      this.orderHospitalId = 0;
      let result = await this.$http.get(this.$url.studentIdByList, {
        studentId: this.sid,
      });

      this.orderList = result.data.data.orderDetailList;
      this.sumPrice = result.data.data.sumPrice;
      this.consumptionNumber = result.data.data.consumptionNumber;
      this.memberLevel = result.data.data.memberLevel;
      this.packageName = result.data.data.packageName;
      this.pointBalance = result.data.data.pointBalance;
      this.residueNumber = result.data.data.residueNumber;
      this.storeValueBalance = result.data.data.storeValueBalance;
      this.orderHospitalId = result.data.data.hospitalId;
    },

    onGoDicomDetail(item) {
      location.href = item.dicomUrl;
    },
    /**
     * 获得曲线数据
     */
    async getLine(sid) {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.checkLine, {
        studentId: sid,
        ctrlType: 0,
        auth: auth.code,
        time: auth.time,
      });
      if (result.message === "Error: Miss auth parameter.") {
        setTimeout(() => {
          this.getLine(sid);
        }, 500);
      } else {
        /** 视力数据对象 */
        this.returnVersionMap = result.data?.returnVersionMap;
        if (this.returnVersionMap != null) {
          this.rightAvgVersion = this.returnVersionMap.rightAvgVersion;
          this.rightVisionList =
            this.returnVersionMap.visionList.rightVisionList;
          this.leftAvgVersion = this.returnVersionMap.leftAvgVersion;
          this.leftVisionList = this.returnVersionMap.visionList.leftVisionList;
          this.rightVisionList.arr = new Array();
          this.leftVisionList.arr = new Array();
          this.rightVisionList.arr[0] = this.rightAvgVersion;
          this.leftVisionList.arr[0] = this.leftAvgVersion;
          this.onFormatList(this.rightVisionList, this.ageList, 1);
          this.onFormatList(this.leftVisionList, this.ageList, 2);
        }

        this.gyMapList = result.data?.gyMapList;
        if (this.gyMapList != null) {
          this.rightGyList = this.gyMapList.rightGyList;
          this.leftGyList = this.gyMapList.leftGyList;
          this.rightGyList.arr = new Array();
          this.leftGyList.arr = new Array();
          this.onFormatList(this.rightGyList, this.ageList, 9);
          this.onFormatList(this.leftGyList, this.ageList, 10);
          this.onFormatList(this.rightGyList, this.ageList, 11);
          this.onFormatList(this.leftGyList, this.ageList, 12);
        }

        /** 屈光数据对象 */
        this.returnDiopterRecordMap = result.data?.returnDiopterRecordMap;
        if (this.returnDiopterRecordMap != null) {
          this.leftAvgDiopterRecord =
            this.returnDiopterRecordMap.leftAvgDiopterRecord;
          this.rightAvgDiopterRecord =
            this.returnDiopterRecordMap.rightAvgDiopterRecord;
          this.leftSeList = this.returnDiopterRecordMap.seList.leftSeList;
          this.rightSeList = this.returnDiopterRecordMap.seList.rightSeList;
          this.leftSeList.arr = new Array();
          this.rightSeList.arr = new Array();
          this.rightSeList.arr[0] = this.rightAvgDiopterRecord;
          this.leftSeList.arr[0] = this.leftAvgDiopterRecord;
          this.onFormatList(this.rightSeList, this.ageList, 3);
          this.onFormatList(this.leftSeList, this.ageList, 4);
        }

        /** 眼压数据对象 */
        this.leftPressureList =
          result && result.data
            ? result.data.pressureList.leftPressureList
            : "";
        this.rightPressureList =
          result && result.data
            ? result.data.pressureList.rightPressureList
            : "";
        this.rightPressureList.arr = new Array();
        this.leftPressureList.arr = new Array();
        this.onFormatList(this.rightPressureList, this.ageList, 5);
        this.onFormatList(this.leftPressureList, this.ageList, 6);

        /** 眼轴数据对象 */
        this.returnAxialLengthMap = result.data?.returnAxialLengthMap;
        this.leftAxialLengthList =
        this.returnAxialLengthMap.axialLengthList.leftAxialLengthList;
        this.rightAxialLengthList =
        this.returnAxialLengthMap.axialLengthList.rightAxialLengthList;
        this.leftAvgAxialLength = this.returnAxialLengthMap.leftAvgAxialLength;
        this.rightAvgAxialLength =
        this.returnAxialLengthMap.rightAvgAxialLength;
        this.rightAxialLengthList.arr = new Array();
        this.leftAxialLengthList.arr = new Array();
        this.leftAxialLengthList.arr[0] = this.leftAvgAxialLength;
        this.rightAxialLengthList.arr[0] = this.rightAvgAxialLength;
        this.onFormatList(this.rightAxialLengthList, this.ageList, 7);
        this.onFormatList(this.leftAxialLengthList, this.ageList, 8);

        /** 预测数据对象 */
        this.leftMap = result.data?.leftMap;
        this.leftAgeList = this.leftMap.ageList;
        this.leftValue = this.leftMap.valueList;
        this.rightMap = result.data.rightMap;
        this.rightAgeList = this.rightMap.ageList;
        this.rightValue = this.rightMap.valueList;
      }
    },
    /**
     * 格式化曲线数据
     */
    onFormatList(list, agelist, type) {
      const { arr, arr1, arrStandard } = formatList(list, agelist, type);
      if (type == 1) {
        this.rightVisionList.arr[1] = arr;
        this.rightVisionList.arrStandard = arrStandard;
      }
      if (type == 2) {
        this.leftVisionList.arr[1] = arr;
        this.leftVisionList.arrStandard = arrStandard;
      }
      if (type == 3) {
        this.rightSeList.arr[1] = arr;
        this.rightSeList.arrStandard = arrStandard;
      }
      if (type == 4) {
        this.leftSeList.arr[1] = arr;
        this.leftSeList.arrStandard = arrStandard;
      }
      if (type == 5) {
        this.rightPressureList.arr[0] = arr;
        this.rightPressureList.arrStandard = arrStandard;
      }
      if (type == 6) {
        this.leftPressureList.arr[0] = arr;
        this.leftPressureList.arrStandard = arrStandard;
      }
      if (type == 7) {
        this.rightAxialLengthList.arr[1] = arr;
        this.rightAxialLengthList.arr[2] = arr1;
        this.rightAxialLengthList.arrStandard = arrStandard;
      }
      if (type == 8) {
        this.leftAxialLengthList.arr[1] = arr;
        this.leftAxialLengthList.arr[2] = arr1;
        this.leftAxialLengthList.arrStandard = arrStandard;
      }
      if (type == 9) {
        this.rightGyList.arr[0] = arr;
        this.rightGyList.arrStandard = arrStandard;
      }
      if (type == 10) {
        this.leftGyList.arr[0] = arr;
        this.leftGyList.arrStandard = arrStandard;
      }
      if (type == 11) {
        this.rightGyList.arr[1] = arr;
        this.rightGyList.arr[2] = arr1;
        this.rightGyList.arrStandard = arrStandard;
      }
      if (type == 12) {
        this.leftGyList.arr[1] = arr;
        this.leftGyList.arr[2] = arr1;
        this.leftGyList.arrStandard = arrStandard;
      }
    },

    goUpdate() {
      this.$router.push(
        `/ysgDetail?screenType=${this.$route.query.screenType}&hospitalId=${this.$route.query.hospitalId}&openId=${this.$route.query.openId}&sid=${this.$route.query.sid}&type=1&isUpdate=1`
      );
    },
    goDel() {
      this.isShowConfirm = true;
    },
    goCancel() {
      this.isShowConfirm = false;
    },
    async deleteHea() {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.put(this.$url.deleteHeaInfo, {
        uid: this.$route.query.sid,
        auth: auth.code,
        time: auth.time,
      });
      if (result.data) {
        this.$toast(result.data.result);
      } else {
        this.$toast("删除档案失败！");
      }
      setTimeout(function () {
        history.go(-1);
      }, 1000);
      this.isShowConfirm = false;
    },

    sortData(obj, eyeChartNames, leftEyeChartValues, rightEyeChartValues) {
      if (obj != null && obj != "" && obj[eyeChartNames] != null) {
        let obj1 = obj[eyeChartNames];
        let obj2 = obj[leftEyeChartValues];
        let obj3 = obj[rightEyeChartValues];
        let len = obj1 == null || obj1 == "" ? 0 : obj1.length;
        if (len > 0) {
          let obj4 = new Array();
          for (let loop = 0; loop < len; loop++) {
            obj4[loop] = {
              val1: obj1[loop],
              val2: obj2[loop],
              val3: obj3[loop],
            };
          }
          obj4.sort(function (a, b) {
            if (a.val1 > b.val1) return 1;
            else if (a.val1 < b.val1) return -1;
            else return 0;
          });
          let loopEnd = 0;
          let obj5 = [];
          let obj6 = [];
          let obj7 = [];
          for (let loop = 0; loop < obj4.length; loop++) {
            if (obj4[loop].val1 != "") {
              obj5[loopEnd] = obj4[loop].val1;
              obj6[loopEnd] = obj4[loop].val2;
              obj7[loopEnd] = obj4[loop].val3;
              loopEnd++;
            }
          }
          obj[eyeChartNames] = obj5;
          obj[leftEyeChartValues] = obj6;
          obj[rightEyeChartValues] = obj7;
        }
      }
      return obj;
    },
    desensitizationName(name) {
      let arr = Array.from(name);
      let result = "";
      if (arr.length === 2) {
        result = arr[0] + "*";
      } else if (arr.length > 2) {
        for (let i = 1; i < arr.length - 1; i++) {
          arr[i] = "*";
        }
        result = arr.join("");
      } else {
        return name;
      }
      return result;
    },
    // 分享
    async goShare(config, name) {
      let that = this;

      let urlAll = window.location.href;
      let shareLinkUrl = "";
      let data = { accountId: "", url: "" };
      data.accountId = config.id;
      if (urlAll.indexOf("#") > 0) {
        data.url = urlAll.split("#")[0];
      } else {
        data.url = urlAll;
      }
      shareLinkUrl = urlAll;
      this.shareLink = shareLinkUrl;
      this.shareName = name;
      this.$http
        .get("/eyeHealth/wxUserChatController/getConfig", {
          url: location.href.split("#")[0],
          accountId: config.id,
        })
        .then(function (res) {
          let wxconf = res.data.config;
          wx.config({
            debug: false,
            appId: wxconf.appId, // 必填，公众号的唯一标识
            timestamp: wxconf.timestamp, // 必填，生成签名的时间戳
            nonceStr: wxconf.nonceStr, // 必填，生成签名的随机串
            signature: wxconf.signature, // 必填，签名
            jsApiList: [
              "onMenuShareTimeline", // 朋友圈
              "onMenuShareAppMessage", // 朋友
            ], // 必填，需要使用的JS接口列表
            openTagList: ["wx-open-launch-weapp"], // 可选，需要使用的开放标签列表
          });
          that.shareConfig2 = {
            debug: false,
            appId: wxconf.appId, // 必填，公众号的唯一标识
            timestamp: wxconf.timestamp, // 必填，生成签名的时间戳
            nonceStr: wxconf.nonceStr, // 必填，生成签名的随机串
            signature: wxconf.signature, // 必填，签名
            jsApiList: [
              "onMenuShareTimeline", // 朋友圈
              "onMenuShareAppMessage", // 朋友
            ], // 必填，需要使用的JS接口列表
            openTagList: ["wx-open-launch-weapp"], // 可选，需要使用的开放标签列表
          };
          wx.ready(function () {
            let share_config = {
              title: name, // 分享标题
              desc: "眼健康在线", // 分享描述
              link: shareLinkUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: encodeURI(
                "http://alime-base-pic.oss-cn-zhangjiakou.aliyuncs.com/channel/1155227/1652936309992_bed2e789cc1f49d89792db573864ea59.jpg"
              ), // 分享图标
              success: function () {
                // 设置成功

                that.shareResult = "用户分享成功";
                console.log("用户分享成功");
              },
              cancel: function () {
                console.log("用户取消分享");
                // 用户取消分享后执行的回调函数
              },
            };
            wx.onMenuShareAppMessage(share_config);
            wx.onMenuShareTimeline(share_config);
          });
          wx.error(function (err) {
            that.shareResult = err;
            console.log(err);
          });
        })
        .catch(function (err) {
          that.shareResult = "err2:" + err;
          console.log(err);
        });
    },
	validateMedicalInfo() {
		const medicalInfo = this.medicalInfo;
	    if (!medicalInfo) return false;
	
	    // 第一组：show1-show4检查
	    const group1 = ['show1', 'show2', 'show3', 'show4'].some(key => 
	        Boolean(medicalInfo[key])
	    );
	
	    // 第二组：牙齿信息检查
	    const teethFields = [
	        'babyTeethQu', 'babyTeethShi', 'babyTeethBu',
	        'permanentTeethQu', 'permanentTeethShi', 'permanentTeethBu'
	    ];
	    const group2 = teethFields.some(key => 
	        medicalInfo[key] !== undefined && 
	        medicalInfo[key] !== null && 
	        medicalInfo[key] !== ''
	    );
	
	    // 第三组：侧弯信息检查（排除'无侧弯'）
	    // const spineFields = [
	    //     'show5', 'show6', 'show7', 'show8', 
	    //     'show9', 'show10', 'show11', 'show12'
	    // ];
	    // const group3 = spineFields.some(key => {
	    //     const value = medicalInfo[key];
	    //     return value !== undefined && 
	    //            value !== null && 
	    //            value !== '' && 
	    //            value !== '无侧弯';
	    // });
		
		// 脊柱
		const spineFields = [
		    'adamResult', 'generalResult', 'chestRot', 'waistChestRot', 
		    'waistRot', 'isSpineTest', 'forwardBackCheck', 'spineHistory', 'initialResult'
		];
		const group3 = spineFields.some(key => {
		    const value = medicalInfo[key];
		    return value != null && value !== '';
		}) && this.reportVersion;
		
	    // 第四组：基本健康信息检查
	    const basicFields = [
	        'sg', 'tz', 'xy', 'show13', 'show14', 'show15', 'show16'
	    ];
	    const group4 = basicFields.some(key => 
	        medicalInfo[key] !== undefined && 
	        medicalInfo[key] !== null && 
	        medicalInfo[key] !== ''
	    );
	    // 如果所有组都是false，则返回false
	    this.medicalInfoHasValue = group1 || group2 || group3 || group4;
	}

  },
  filters: {
    formatAge,
    formatWeight,
    formatHeight,
    formatVal,
    formatGy,
    formatFixed2,
    formatDate,
    formatShili,
  },
};
</script>
<style scope lang="less">
@import "./css/detail.less";
.width-4-1{
  width: 35%;
}
.width-4-2{
  width: 17%;
  text-align: center;
}
.width-4-3{
  width: 35%;
}
.width-4-4{
  width: 13%;
  text-align: center;
}

.van-tab {
	font-size: 1em;
}

.liter-title{
	text-align: center;
	padding-top: 0.2rem;
	font-weight: 600;
	margin: 0 0.3rem 0 0.3rem;
	line-height: 2em;
	border-bottom: 1px solid #5CC4AB;
	font-weight: bold;
	color: #5CC4AB;
}


.disease {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
	flex-wrap: wrap;
	height: 0.7rem; 
}

.disease-radio {
	display: flex;
	align-items: center;
	
}


.fa {
	margin-bottom: 2px;
    display: inline-block;
    font: normal normal normal 14px/1 FontAwesome;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* 新增修复样式 */
    width: 1em;
    height: 1em;
    line-height: 1;
    text-align: center;
    vertical-align: middle;
}

.fa-background {
	width: 1.1em;
	height: 1.1em;
	border-radius: 50%;
	align-items: center;
	color: white;
	background-color: #5CC4AB;
}

 
.fa-background-disabled {
	width: 1.1em;
	height: 1.1em;
	border-radius: 50%;
	align-items: center;
	color: #c8c8c8;
	background-color: #c8c8c8;
}

/* 简单样式，可按需调整 */
.new-report-div {
  border-collapse: collapse;
  width: 340px;
  margin: 20px auto;
  text-align: center;
  .new-report-title {
    width: 100%;
    background-color: #5CC4AB;
    color: white;
    padding: 10px 0;
    margin-bottom: 10px;
    border-radius: 5px;
  }
  .new-report-table {
    border: 1px solid #ccc;
    border-collapse: collapse; /* 合并相邻边框 */
    width: 100%;
    font-size: 14px;
  }
  .new-report-tip {
    margin-top: 4px;
    font-size: 12px;
    color: #5CC4AB;
    text-align: left;
  }
}
.new-report-div th,
.new-report-div td {
  border: 1px solid #ccc;
  padding: 8px;
}

.new-report-div th {
  color: #5CC4AB;
}


.van-radio__icon {
	font-size: 1em;
}

.van-radio__label {
	line-height: 1.02em;
	display: inline-flex;
	align-items: center;
	vertical-align: middle;
	margin-left: 0.5em;
}

.van-radio {
	display: inline-flex;
	align-items: center;
	vertical-align: middle;
}
</style>
